import { defineComponent, ref, computed, onBeforeMount, onMounted, openBlock, createElementBlock, unref, normalizeClass, normalizeStyle, renderSlot, inject, createElementVNode, normalizeProps, guardReactiveProps, createVNode, withCtx, createBlock, createCommentVNode, toDisplayString, mergeProps, watch, Fragment, renderList, createTextVNode, onUnmounted, resolveDynamicComponent, mergeModels, useModel, withModifiers, toRef, nextTick, resolveComponent, withKeys, Transition, withDirectives, vShow, onErrorCaptured, useSlots, reactive, onBeforeUnmount, resolveDirective, Teleport, toValue, useAttrs, provide, toRefs, createSlots } from 'vue';
import { u as useTheme, T as ThemeTypes, k as _export_sfc, e as _sfc_main$X, j as _sfc_main$Y, h as DSPopup, f as DSListboxInput, d as DSDateCalendarInput, c as _sfc_main$Z, _ as _sfc_main$_, D as DSCalendar, a as DSCalendarInput, b as _sfc_main$$, g as _sfc_main$10, i as _sfc_main$11 } from './DSRadioInput.vue_vue_type_script_setup_true_lang-BYPjfzz_.js';
import { useMutationObserver, useElementSize, watchThrottled, useResizeObserver, useScroll, useElementBounding, toReactive } from '@vueuse/core';
import { c as useId, b as useI18n, d as useI18n$1, u as useBreakpoints } from './useBreakpoints-Cx1EETam.js';
import { u as useClipboard, a as useDeprecated, d as useGroupData, b as useModal, c as useNotifier, f as useStackingItem } from './useStackingItem-DFvE8bpP.js';
import { Combobox, ComboboxOptions, ComboboxOption, ComboboxInput, ComboboxButton, Menu, MenuButton, MenuItems, MenuItem, TransitionRoot, Dialog, TransitionChild, DialogPanel } from '@headlessui/vue';
import { d as debounce } from './groupData-Dl8C-s_B.js';
import { s as safeIsEqual, a as useDayjs, g as generateTimeRange, d as deepCopy } from './deepCopy-BPIPBkff.js';
import { Vue3Lottie } from 'vue3-lottie';
import { flatten } from 'flat';
import { Float } from '@headlessui-float/vue';
import { OnClickOutside } from '@vueuse/components';
import { v4 } from 'uuid';
import 'vue-router';
import { r as resolve } from './resolve-CcNBIfOU.js';
import { v as vFocus } from './focus-Dhhiawn_.js';

const _hoisted_1$r = ["id"];
const _sfc_main$W = /* @__PURE__ */ defineComponent({
  __name: "DSCollapse",
  props: {
    initialState: {},
    collapsedHeight: {},
    customThemeObject: {}
  },
  emits: ["show", "shown", "hide", "hidden"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const height = ref(void 0);
    const el = ref(null);
    const id = useId();
    const collapsed = ref(void 0);
    function getHeight() {
      if (el.value)
        height.value = el.value.scrollHeight;
    }
    useMutationObserver(el, () => {
      getHeight();
    }, {
      childList: true,
      subtree: true
    });
    const collapsedHeightText = computed(() => `${props.collapsedHeight || 0}px`);
    const heightText = computed(() => `${height.value || 0}px`);
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.COLLAPSE, props.customThemeObject);
      return componentClasses;
    });
    function show() {
      getHeight();
      collapsed.value = false;
      emit("show");
      setTimeout(() => emit("shown"), 500);
    }
    function hide() {
      getHeight();
      collapsed.value = true;
      emit("hide");
      setTimeout(() => emit("hidden"), 500);
    }
    const toggle = () => collapsed.value ? show() : hide();
    onBeforeMount(() => {
      collapsed.value = props.initialState !== "expanded";
    });
    onMounted(() => {
      getHeight();
    });
    __expose({
      show,
      hide,
      toggle,
      collapsed,
      id
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: `collapse-${unref(id)}`,
        ref_key: "el",
        ref: el,
        "data-ds-component": "collapse",
        class: normalizeClass({ show: !collapsed.value, [theme.value.container]: true }),
        style: normalizeStyle({
          "max-height": collapsed.value ? collapsedHeightText.value : heightText.value
        })
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 14, _hoisted_1$r);
    };
  }
});

const _sfc_main$V = {
  __name: 'DSAccordion',
  props: {
  initialState: String,
  disabled: Boolean,
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

// TODO: ARIA, ids
const props = __props;
const accordionBus = inject('accordionBus', undefined);
const collapsed = ref(undefined);
const transitioning = ref(false);
const collapse = ref(null);

collapsed.value = props.initialState !== 'expanded';

const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.ACCORDION, props.customThemeObject);
  return componentClasses
});

if (accordionBus) {
  accordionBus.on(
    'hide-all',
    () => {
      hide();
    },
  );
}

function show() {
  if (props.disabled)
    return
  accordionBus?.emit('hide-all');
  collapse.value?.show();
}

function hide() {
  if (props.disabled)
    return
  collapse.value?.hide();
}

function toggle() {
  if (props.disabled)
    return
  collapsed.value ? show() : hide();
}

function onShow() {
  collapsed.value = false;
  transitioning.value = true;
}

function onHide() {
  collapsed.value = true;
  transitioning.value = true;
}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    "data-ds-component": "accordion",
    class: normalizeClass({ disabled: __props.disabled, [theme.value.container]: true })
  }, [
    createElementVNode("button", {
      type: "button",
      class: normalizeClass({ [theme.value.accordionHeaderCollapsed]: collapsed.value && !transitioning.value, [theme.value.accordionHeader]: true }),
      onClick: toggle
    }, [
      createElementVNode("div", {
        class: normalizeClass(theme.value.accordionHeaderIconWrapper)
      }, [
        renderSlot(_ctx.$slots, "icon", normalizeProps(guardReactiveProps({ collapsed: collapsed.value })), () => [
          createElementVNode("div", {
            class: normalizeClass([collapsed.value ? theme.value.accordionHeaderIconCollapsed : theme.value.accordionHeaderIconExpanded, theme.value.accordionHeaderIcon])
          }, null, 2)
        ], true)
      ], 2),
      createElementVNode("div", {
        class: normalizeClass(theme.value.accordionHeaderSlotWrapper)
      }, [
        renderSlot(_ctx.$slots, "header", normalizeProps(guardReactiveProps({ collapsed: collapsed.value })), undefined, true)
      ], 2)
    ], 2),
    createVNode(_sfc_main$W, {
      ref_key: "collapse",
      ref: collapse,
      "initial-state": __props.initialState,
      onShow: onShow,
      onShown: _cache[0] || (_cache[0] = $event => (transitioning.value = false)),
      onHide: onHide,
      onHidden: _cache[1] || (_cache[1] = $event => (transitioning.value = false))
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(theme.value.accordionBody)
        }, [
          renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ collapsed: collapsed.value })), undefined, true)
        ], 2)
      ]),
      _: 3
    }, 8, ["initial-state"])
  ], 2))
}
}

};
const DSAccordion = /*#__PURE__*/_export_sfc(_sfc_main$V, [['__scopeId',"data-v-13691d71"]]);

var AlertTypeNames = /* @__PURE__ */ ((AlertTypeNames2) => {
  AlertTypeNames2["WARNING"] = "warning";
  AlertTypeNames2["INFO"] = "info";
  AlertTypeNames2["SUCCESS"] = "success";
  AlertTypeNames2["DANGER"] = "danger";
  return AlertTypeNames2;
})(AlertTypeNames || {});

const _hoisted_1$q = ["aria-label"];
const _hoisted_2$a = { class: "sr-only" };
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "DSAlert",
  props: {
    type: { default: AlertTypeNames.INFO },
    noIcon: { type: Boolean, default: false },
    noClose: { type: Boolean, default: false },
    iconClass: {},
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.ALERT_COMPONENT, props.customThemeObject);
      return componentClasses;
    });
    const currentType = computed(() => {
      const types = {
        warning: {
          classes: theme.value.warning,
          icon: theme.value.alertWarningIcon,
          hover: theme.value.alertWarningHover
        },
        info: {
          classes: theme.value.info,
          icon: theme.value.alertInfoIcon,
          hover: theme.value.alertInfoHover
        },
        success: {
          classes: theme.value.success,
          icon: theme.value.alertSuccessIcon,
          hover: theme.value.alertSuccessHover
        },
        danger: {
          classes: theme.value.danger,
          icon: theme.value.alertDangerIcon,
          hover: theme.value.alertDangerHover
        }
      };
      const { classes, icon, hover } = types[props.type] || types.info;
      return {
        classes,
        icon,
        hover
      };
    });
    const { t } = useI18n();
    const open = ref(true);
    return (_ctx, _cache) => {
      return open.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        "data-ds-component": "alert",
        class: normalizeClass([theme.value.container, currentType.value.classes])
      }, [
        createElementVNode("div", {
          class: normalizeClass(theme.value.alertContentWrapper)
        }, [
          createElementVNode("div", {
            class: normalizeClass(theme.value.alertContent)
          }, [
            !_ctx.noIcon ? (openBlock(), createBlock(_sfc_main$X, {
              key: 0,
              icon: props.iconClass || currentType.value.icon,
              size: "24"
            }, null, 8, ["icon"])) : createCommentVNode("", true),
            createElementVNode("div", {
              class: normalizeClass(theme.value.alertContentSlot)
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 2)
          ], 2),
          _ctx.$slots.cta !== void 0 ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(theme.value.alertCtaSlotSmall)
          }, [
            renderSlot(_ctx.$slots, "cta")
          ], 2)) : createCommentVNode("", true),
          !_ctx.noClose ? (openBlock(), createElementBlock("button", {
            key: 1,
            class: normalizeClass([theme.value.alertCloseButton, currentType.value.hover]),
            "aria-label": unref(t)("Close"),
            "data-testid": "ds-alert-close",
            onClick: _cache[0] || (_cache[0] = ($event) => open.value = false)
          }, [
            createElementVNode("span", _hoisted_2$a, toDisplayString(unref(t)("Close")), 1),
            createVNode(_sfc_main$X, {
              icon: theme.value.alertCloseIcon,
              size: "24"
            }, null, 8, ["icon"])
          ], 10, _hoisted_1$q)) : createCommentVNode("", true)
        ], 2),
        _ctx.$slots.cta !== void 0 ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(theme.value.alertCtaSlotLarge)
        }, [
          renderSlot(_ctx.$slots, "cta")
        ], 2)) : createCommentVNode("", true)
      ], 2)) : createCommentVNode("", true);
    };
  }
});

function block0$e (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Close": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Close"}}
      },
      "de": {
        "Close": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Schließen"}}
      },
      "fr": {
        "Close": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Fermer"}}
      },
      "es": {
        "Close": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Cerrar"}}
      }
    }
  });
}

if (typeof block0$e === "function") block0$e(_sfc_main$U);

const _hoisted_1$p = ["aria-label"];


const _sfc_main$T = {
  __name: 'DSSpinnerInline',
  props: {
  customThemeObject: {
    type: Object,
    required: false,
  },
  label: {
    type: String,
    default: 'Loading Spinner',
  },
},
  setup(__props) {

const props = __props;

const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.SPINNER, props.customThemeObject);
  return componentClasses
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("span", mergeProps({
    "data-ds-component": "spinner",
    class: theme.value.spinnerInline
  }, _ctx.$attrs, {
    role: "status",
    "aria-label": __props.label
  }), null, 16, _hoisted_1$p))
}
}

};

const _hoisted_1$o = ["disabled"];
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "DSAsyncButton",
  props: {
    labelProcessing: {},
    validations: {},
    customThemeObject: {}
  },
  emits: ["fail", "submit"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { t } = useI18n();
    const wasClicked = ref(false);
    const isProcessing = ref(false);
    function onClick() {
      wasClicked.value = true;
      isProcessing.value = true;
      if (!isValid()) {
        emit("fail");
        isProcessing.value = false;
        return;
      }
      emit("submit", finishProcessing);
    }
    function isValid() {
      if (wasClicked.value && props.validations && Array.isArray(props.validations) && !props.validations.every((f) => f()))
        return false;
      else return true;
    }
    function finishProcessing() {
      isProcessing.value = false;
    }
    const labelProcessingDisplay = computed(() => {
      return props.labelProcessing ? props.labelProcessing : `${t("Processing")}...`;
    });
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.ASYNC_BUTTON, props.customThemeObject);
      return componentClasses;
    });
    watch(
      isProcessing,
      (val) => {
        if (val) {
          setTimeout(
            () => {
              isProcessing.value = false;
            },
            10 * 1e3
          );
        }
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", mergeProps({
        class: theme.value.container,
        "data-ds-component": "async-button",
        "data-testid": "ds-async-button",
        disabled: isProcessing.value
      }, _ctx.$attrs, { onClick }), [
        createElementVNode("div", {
          class: normalizeClass(theme.value.asyncButtonContent)
        }, [
          !isProcessing.value ? renderSlot(_ctx.$slots, "default", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createVNode(_sfc_main$T, {
              class: normalizeClass(theme.value.asyncButtonSpinner),
              label: labelProcessingDisplay.value
            }, null, 8, ["class", "label"]),
            createElementVNode("div", {
              class: normalizeClass(theme.value.asyncButtonText),
              "data-testid": "ds-async-button-processing-label"
            }, toDisplayString(labelProcessingDisplay.value), 3)
          ], 64))
        ], 2)
      ], 16, _hoisted_1$o);
    };
  }
});

function block0$d (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Processing": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Processing"}}
      },
      "es": {
        "Processing": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Procesando"}}
      }
    }
  });
}

function block1$6 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "de",
    "resource": {
      "Processing": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Wird verarbeitet"}}
    }
  });
}

function block2$6 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "Processing": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Traitement en cours"}}
    }
  });
}

if (typeof block0$d === "function") block0$d(_sfc_main$S);
if (typeof block1$6 === "function") block1$6(_sfc_main$S);
if (typeof block2$6 === "function") block2$6(_sfc_main$S);

const settingsBySize = {
  xs: {
    dim: 24,
    text: 12,
  },
  sm: {
    dim: 32,
    text: 12,
  },
  md: {
    dim: 48,
    text: 16,
  },
  lg: {
    dim: 80,
    text: 30,
  },
  xl: {
    dim: 144,
    text: 48,
  },
};

const _hoisted_1$n = ["aria-label"];
const _hoisted_2$9 = { "data-testid": "ds-avatar-text" };
const _hoisted_3$4 = { class: "sr-only" };
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "DSAvatarText",
  props: {
    size: { default: "xs" },
    text: {},
    name: {},
    customThemeObject: { default: null }
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.AVATAR, props.customThemeObject);
      return componentClasses;
    });
    const { t } = useI18n();
    const computedTextSizeClass = computed(() => {
      const size = props.size;
      const textSettingBySize = settingsBySize[size].text;
      switch (textSettingBySize) {
        case 48:
          return "text-48px";
        case 30:
          return "text-30px";
        case 16:
          return "text-16px";
        case 12:
        default:
          return "text-12px";
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([computedTextSizeClass.value, theme.value.avatarText]),
        "aria-label": `${_ctx.name} ${unref(t)("Profile")}`,
        role: "img"
      }, [
        createElementVNode("span", _hoisted_2$9, toDisplayString(_ctx.text), 1),
        createElementVNode("span", _hoisted_3$4, toDisplayString(`${_ctx.name} ${unref(t)("Profile")}`), 1)
      ], 10, _hoisted_1$n);
    };
  }
});

function block0$c (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Profile": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Profile"}}
      }
    }
  });
}

if (typeof block0$c === "function") block0$c(_sfc_main$R);

const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "DSAvatarTemplate",
  props: {
    size: { default: "xs" },
    shape: { default: "circle" },
    border: { type: Boolean, default: false },
    customThemeObject: { default: null }
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.AVATAR, props.customThemeObject);
      return componentClasses;
    });
    const ringStyle = computed(() => {
      switch (props.size) {
        case "xl":
        case "lg":
          return theme.value.avatarRingStyleLg;
        case "md":
          return theme.value.avatarRingStyleMd;
        default:
          return theme.value.avatarRingStyleDefault;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createElementVNode("div", {
          class: normalizeClass([
            _ctx.shape === "square" ? theme.value.avatarTemplateSquare : theme.value.avatarTemplateHalfRounded,
            _ctx.border && `${ringStyle.value} ${theme.value.avatarBorder}`,
            theme.value.avatarTemplate
          ]),
          style: normalizeStyle({
            "width": `${unref(settingsBySize)[_ctx.size].dim}px`,
            "height": `${unref(settingsBySize)[_ctx.size].dim}px`,
            "line-height": `${unref(settingsBySize)[_ctx.size].dim}px`
          })
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 6)
      ]);
    };
  }
});

const _hoisted_1$m = ["data-size", "data-shape", "data-border"];
const _hoisted_2$8 = ["src", "alt"];
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "DSAvatar",
  props: {
    name: {},
    size: { default: "xs" },
    shape: { default: "circle" },
    imageUrl: {},
    border: { type: Boolean, default: false },
    customThemeObject: { default: null }
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.AVATAR, props.customThemeObject);
      return componentClasses;
    });
    const imageSrc = computed(() => {
      const url = props.imageUrl;
      if (!url)
        return;
      const dim = settingsBySize[props.size].dim;
      const urlPath = url.includes("?") ? url.substr(0, url.indexOf("?")) : url;
      return `${urlPath}?w=${dim}&h=${dim}`;
    });
    const initials = computed(() => {
      if (!props.name)
        return null;
      return props.name.match(/(^\S?|\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(theme.value.container),
        "data-ds-component": "avatar",
        "data-size": _ctx.size,
        "data-shape": _ctx.shape,
        "data-border": _ctx.border
      }, [
        createVNode(_sfc_main$Q, {
          size: _ctx.size,
          shape: _ctx.shape,
          border: _ctx.border,
          "custom-theme-object": props.customThemeObject
        }, {
          default: withCtx(() => [
            imageSrc.value ? (openBlock(), createElementBlock("img", {
              key: 0,
              class: normalizeClass(theme.value.avatarImage),
              "data-testid": "ds-avatar-image",
              style: normalizeStyle({
                width: `${unref(settingsBySize)[_ctx.size].dim}px`,
                height: `${unref(settingsBySize)[_ctx.size].dim}px`
              }),
              src: imageSrc.value,
              alt: `${_ctx.name} ${unref(t)("Profile")}`,
              role: "img"
            }, null, 14, _hoisted_2$8)) : (openBlock(), createBlock(_sfc_main$R, {
              key: 1,
              "data-testid": "ds-avatar-text-component",
              size: _ctx.size,
              text: initials.value,
              name: _ctx.name,
              "custom-theme-object": props.customThemeObject
            }, null, 8, ["size", "text", "name", "custom-theme-object"]))
          ]),
          _: 1
        }, 8, ["size", "shape", "border", "custom-theme-object"])
      ], 10, _hoisted_1$m);
    };
  }
});

function block0$b (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Profile": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Profile"}}
      },
      "es": {
        "Profile": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Perfil"}}
      }
    }
  });
}

if (typeof block0$b === "function") block0$b(_sfc_main$P);

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'end'];
const placements = /*#__PURE__*/sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = autoPlacement$1;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = shift$1;

const _hoisted_1$l = ["aria-label", "onClick"];
const _hoisted_2$7 = /* @__PURE__ */ createElementVNode("br", null, null, -1);
const _hoisted_3$3 = ["onClick"];
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "DSAvatarList",
  props: {
    max: { default: 4 },
    size: { default: "md" },
    people: {},
    border: { type: Boolean },
    dualAvatar: { type: Boolean, default: false },
    customThemeObject: { default: null }
  },
  emits: ["selectPerson"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.AVATARLIST, props.customThemeObject);
      return componentClasses;
    });
    const maxAvatars = computed(() => {
      if (props.dualAvatar)
        return 2;
      else
        return props.max;
    });
    const peopleWithAvatars = computed(() => {
      return props.people ? props.people.slice(0, maxAvatars.value) : [];
    });
    const hasSomeHidden = computed(() => {
      return props.people?.length > maxAvatars.value;
    });
    function selectPerson(id) {
      emit("selectPerson", id);
    }
    function setSpaceBetweenButtons(index) {
      if (index !== 0) {
        if (props.size === "lg")
          return theme.value.avatarListButtonLg;
        else if (props.size === "md" && props.dualAvatar)
          return theme.value.avatarListButtonMd;
        else
          return theme.value.avatarListButtonSm;
      }
    }
    function tiltPosition(index) {
      return props.dualAvatar && index === 1 && theme.value.avatarListDualAvatar;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "data-ds-component": "avatar-list",
        class: normalizeClass(theme.value.container)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(peopleWithAvatars.value, (person, i) => {
          return openBlock(), createElementBlock("div", {
            key: `avatar-${i}`,
            class: normalizeClass([
              `avatar-${i}`,
              tiltPosition(i),
              theme.value.avatarListPerson
            ]),
            "data-testid": "ds-avatar-list-items"
          }, [
            createVNode(_sfc_main$Y, {
              variant: "dark",
              placement: "top",
              "other-classes": theme.value.avatarListTooltip
            }, {
              content: withCtx(() => [
                renderSlot(_ctx.$slots, "default", mergeProps({ ref_for: true }, props), () => [
                  createElementVNode("div", {
                    "data-testid": "ds-avatar-tooltip-content",
                    class: normalizeClass(theme.value.avatarListInfo)
                  }, [
                    createTextVNode(toDisplayString(person.name), 1),
                    _hoisted_2$7,
                    createTextVNode(),
                    createElementVNode("span", {
                      class: normalizeClass(theme.value.avatarListEmail),
                      style: { "font-size": "10px" }
                    }, toDisplayString(person.email ? person.email : ""), 3)
                  ], 2)
                ])
              ]),
              default: withCtx(() => [
                createElementVNode("button", {
                  class: normalizeClass(setSpaceBetweenButtons(i)),
                  "aria-label": person.name,
                  "data-testid": "ds-avatar-tooltip-button",
                  role: "button",
                  onClick: ($event) => selectPerson(person.id)
                }, [
                  createVNode(_sfc_main$P, {
                    class: normalizeClass(theme.value.avatarListAvatar),
                    name: person.name,
                    "image-url": person.imageUrl,
                    size: props.size,
                    border: props.border
                  }, null, 8, ["class", "name", "image-url", "size", "border"])
                ], 10, _hoisted_1$l)
              ]),
              _: 2
            }, 1032, ["other-classes"])
          ], 2);
        }), 128)),
        hasSomeHidden.value ? (openBlock(), createBlock(DSPopup, {
          key: 0,
          offset: -12,
          middleware: [
            unref(shift)({ padding: 5 }),
            unref(autoPlacement)({
              autoAlignment: false,
              allowedPlacements: ["right", "bottom"]
            })
          ]
        }, {
          content: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(theme.value.avatarListContent)
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(props.people, (person, i) => {
                return openBlock(), createElementBlock("button", {
                  key: `person-${i}`,
                  class: normalizeClass(theme.value.avatarListContentButton),
                  "data-testid": "ds-avatar-popup-list-item",
                  onClick: ($event) => selectPerson(person.id)
                }, [
                  createVNode(_sfc_main$P, {
                    name: person.name,
                    "image-url": person.imageUrl,
                    class: normalizeClass(theme.value.avatarListContentAvatar)
                  }, null, 8, ["name", "image-url", "class"]),
                  createElementVNode("div", {
                    class: normalizeClass(theme.value.avatarListAvatarDetails)
                  }, [
                    createElementVNode("div", {
                      class: normalizeClass(theme.value.avatarListAvatarName)
                    }, toDisplayString(person.name), 3),
                    person.email ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: normalizeClass(theme.value.avatarListAvatarEmail)
                    }, toDisplayString(person.email), 3)) : createCommentVNode("", true)
                  ], 2)
                ], 10, _hoisted_3$3);
              }), 128))
            ], 2)
          ]),
          default: withCtx(() => [
            createElementVNode("button", {
              class: normalizeClass(props.size === "lg" ? theme.value.avatarListButtonLg : props.size === "md" ? theme.value.avatarListButtonMd : theme.value.avatarListButtonSm),
              "data-testid": "ds-avatar-popup-button"
            }, [
              createVNode(_sfc_main$Q, {
                size: props.size,
                "has-border": props.border
              }, {
                default: withCtx(() => [
                  maxAvatars.value && props.people?.length - peopleWithAvatars.value?.length > 0 ? (openBlock(), createBlock(_sfc_main$R, {
                    key: 0,
                    text: `+${(props.people?.length - peopleWithAvatars.value?.length).toString()}`,
                    size: props.size,
                    "avatar-class": theme.value.avatarListAvatarClass,
                    "data-testid": "ds-avatar-overflow-element"
                  }, null, 8, ["text", "size", "avatar-class"])) : createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["size", "has-border"])
            ], 2)
          ]),
          _: 1
        }, 8, ["middleware"])) : createCommentVNode("", true)
      ], 2);
    };
  }
});

const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "DSBackdrop",
  props: {
    customThemeObject: { default: null }
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.BACKDROP, props.customThemeObject);
      return componentClasses;
    });
    onMounted(() => {
      document.querySelector("body").classList.add("overflow-hidden");
    });
    onUnmounted(() => {
      document.querySelector("body").classList.remove("overflow-hidden");
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(theme.value.container),
        "data-ds-component": "backdrop"
      }, null, 2);
    };
  }
});

const _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "DSBreadcrumbs",
  props: {
    crumbs: {},
    chevron: { type: Boolean, default: true },
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const penultimateCrumb = computed(() => {
      return props.crumbs?.length > 1 ? props.crumbs[props.crumbs.length - 2] : void 0;
    });
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.BREADCRUMBS, props.customThemeObject);
      return componentClasses;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "data-ds-component": "breadcrumbs",
        class: normalizeClass(theme.value.container)
      }, [
        createElementVNode("nav", {
          class: normalizeClass(theme.value.breadCrumbsNav)
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.crumbs, (crumb, index) => {
            return openBlock(), createElementBlock(Fragment, {
              key: crumb.label
            }, [
              _ctx.chevron && index > 0 ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(theme.value.breadCrumbsChevron)
              }, null, 2)) : createCommentVNode("", true),
              (openBlock(), createBlock(resolveDynamicComponent(!crumb.url ? "div" : crumb.routerLink ? "router-link" : "a"), {
                to: crumb.url,
                href: crumb.url,
                class: normalizeClass(theme.value.breadCrumbsMainCrumb)
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(crumb.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "href", "class"]))
            ], 64);
          }), 128))
        ], 2),
        penultimateCrumb.value ? (openBlock(), createElementBlock("nav", {
          key: 0,
          class: normalizeClass(theme.value.breadCrumbsPenultimateCrumbNav)
        }, [
          (openBlock(), createBlock(resolveDynamicComponent(!penultimateCrumb.value.url ? "div" : penultimateCrumb.value.routerLink ? "router-link" : "a"), {
            to: penultimateCrumb.value.url,
            href: penultimateCrumb.value.url,
            class: normalizeClass(theme.value.breadCrumbsPenultimateCrumb)
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(theme.value.breadCrumbsIconWrapper)
              }, [
                createVNode(_sfc_main$X, {
                  icon: theme.value.breadCrumbsIcon
                }, null, 8, ["icon"])
              ], 2),
              createElementVNode("div", {
                class: normalizeClass(theme.value.breadCrumbsPenultimateCrumbLabel)
              }, toDisplayString(penultimateCrumb.value.label), 3)
            ]),
            _: 1
          }, 8, ["to", "href", "class"]))
        ], 2)) : createCommentVNode("", true)
      ], 2);
    };
  }
});

const _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "DSImage",
  props: {
    src: {},
    alt: {},
    role: {},
    width: {},
    height: {}
  },
  setup(__props) {
    const props = __props;
    const el = ref(null);
    const { width: detectedWidth, height: detectedHeight } = useElementSize(el);
    let widthMax = -1;
    let heightMax = -1;
    const parameterizedUrl = ref(void 0);
    const computedWidth = computed(() => +props.width || detectedWidth.value || 0);
    const computedHeight = computed(() => +props.height || detectedHeight.value || 0);
    function updateParameterizedUrl() {
      if (props.src?.includes("data:image") || props.src?.includes("blob:")) {
        parameterizedUrl.value = props.src;
        return;
      }
      if (!computedWidth.value && !computedHeight.value)
        return;
      if (computedWidth.value <= widthMax || computedHeight.value <= heightMax)
        return;
      widthMax = Math.max(widthMax, computedWidth.value);
      heightMax = Math.max(heightMax, computedHeight.value);
      const [urlWithoutQueryString] = props.src.split("?");
      parameterizedUrl.value = `${urlWithoutQueryString}?${computedWidth.value > 0 ? `w=${Math.ceil(computedWidth.value)}&` : ""}${computedHeight.value > 0 ? `h=${Math.ceil(computedHeight.value)}` : ""}`;
    }
    watchThrottled(
      () => [computedWidth, computedHeight],
      () => updateParameterizedUrl(),
      {
        deep: true,
        immediate: true,
        throttle: 1e3
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(parameterizedUrl.value ? "img" : "div"), mergeProps({
        ref_key: "el",
        ref: el,
        src: parameterizedUrl.value
      }, {
        ..._ctx.width && { width: _ctx.width },
        ..._ctx.height && { height: _ctx.height }
      }, {
        role: _ctx.role,
        "aria-label": _ctx.role === "img" ? _ctx.alt : null,
        alt: _ctx.role !== "img" ? _ctx.alt : null
      }), null, 16, ["src", "role", "aria-label", "alt"]);
    };
  }
});

const _hoisted_1$k = { key: 2 };
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "DSCard",
  props: {
    shape: { default: "rounded" },
    hasShadow: { type: Boolean, default: false },
    imageUrl: {},
    imageAlt: {},
    heading: {},
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const shapeClass = computed(() => {
      return props.shape === "rounded" ? "rounded-2xl" : "";
    });
    const shadowClass = computed(() => {
      return props.hasShadow ? "shadow-xl" : "";
    });
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.CARD, props.customThemeObject);
      return componentClasses;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "data-ds-component": "card",
        class: normalizeClass(theme.value.container)
      }, [
        createElementVNode("div", {
          "data-testid": "ds-card-container",
          class: normalizeClass([shapeClass.value, shadowClass.value, theme.value.cardInnerContainer])
        }, [
          props.imageUrl || _ctx.$slots.image ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass([shapeClass.value, theme.value.cardImageContainer])
          }, [
            renderSlot(_ctx.$slots, "image", {}, () => [
              createVNode(_sfc_main$L, {
                "data-testid": "ds-card-image",
                src: props.imageUrl,
                alt: props.imageAlt
              }, null, 8, ["src", "alt"])
            ])
          ], 2)) : createCommentVNode("", true),
          props.heading ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(theme.value.cardHeading),
            "data-testid": "ds-card-heading"
          }, toDisplayString(props.heading), 3)) : createCommentVNode("", true),
          createElementVNode("div", null, [
            renderSlot(_ctx.$slots, "default")
          ]),
          _ctx.$slots.footer !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_1$k, [
            renderSlot(_ctx.$slots, "footer")
          ])) : createCommentVNode("", true)
        ], 2)
      ], 2);
    };
  }
});

const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "DSChip",
  props: {
    type: {},
    icon: {},
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.CHIP, props.customThemeObject);
      return componentClasses;
    });
    const currentType = computed(() => {
      const types = {
        alert: theme.value.alert,
        danger: theme.value.danger,
        info: theme.value.info,
        success: theme.value.success,
        warning: theme.value.warning,
        utility: theme.value.utility,
        primary: theme.value.primary,
        secondary: theme.value.secondary,
        tertiary: theme.value.tertiary,
        surface: theme.value.surface
      };
      return types[props.type] || types.primary;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([currentType.value, theme.value.container])
      }, [
        _ctx.$slots.icon || props.icon ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(theme.value.chipIcon)
        }, [
          renderSlot(_ctx.$slots, "icon", {}, () => [
            createVNode(_sfc_main$X, {
              "data-testid": "ds-chip-icon",
              icon: props.icon
            }, null, 8, ["icon"])
          ])
        ], 2)) : createCommentVNode("", true),
        createElementVNode("span", null, [
          renderSlot(_ctx.$slots, "default")
        ])
      ], 2);
    };
  }
});

const _hoisted_1$j = ["innerHTML"];
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "DSClipboard",
  props: {
    copy: {},
    label: {},
    variant: { default: "dark" },
    clipboardApi: { default: () => useClipboard() },
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.CLIPBOARD, props.customThemeObject);
      return componentClasses;
    });
    const { t } = useI18n$1();
    const showTooltip = ref(false);
    async function copyFunction() {
      const { write } = props.clipboardApi;
      await write(props.copy);
    }
    function onClick() {
      copyFunction();
      showTooltip.value = true;
      setTimeout(() => {
        showTooltip.value = false;
      }, 1500);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$Y, {
        "data-ds-component": "clipboard",
        "data-testid": "ds-clipboard-tooltip",
        open: showTooltip.value,
        variant: _ctx.variant,
        arrowless: "",
        "ignore-hover": "",
        "ignore-focus": "",
        onClick
      }, {
        content: withCtx(() => [
          createElementVNode("div", null, [
            createElementVNode("p", {
              "data-testid": "ds-clipboard-tooltip-text",
              class: normalizeClass({ [theme.value.clipboardCopiedLight]: _ctx.variant === "light", [theme.value.clipboardCopied]: true })
            }, toDisplayString(unref(t)("Copied")) + "! ", 3)
          ])
        ]),
        default: withCtx(() => [
          createElementVNode("i", {
            class: normalizeClass(theme.value.clipboardIcon),
            "data-testid": "ds-clipboard-button-icon"
          }, null, 2),
          _ctx.label ? (openBlock(), createElementBlock("span", {
            key: 0,
            "data-testid": "ds-clipboard-button-label",
            class: normalizeClass(theme.value.clipboardLabel),
            innerHTML: _ctx.label
          }, null, 10, _hoisted_1$j)) : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["open", "variant"]);
    };
  }
});

function block0$a (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Copied": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Copied"}}
      },
      "de": {
        "Copied": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Kopiert"}}
      },
      "fr": {
        "Copied": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Copié"}}
      },
      "es": {
        "Copied": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Copiado"}}
      }
    }
  });
}

if (typeof block0$a === "function") block0$a(_sfc_main$I);

const v = "5.5.5";
const fr = 25;
const ip = 0;
const op = 79;
const w = 300;
const h = 150;
const nm = "Loading-2";
const ddd = 0;
const assets = [
];
const layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "icon 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 39,
						s: [
							-90
						]
					},
					{
						t: 79,
						s: [
							270
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					150,
					75,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					53,
					53,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-15.464
									],
									[
										15.464,
										0
									],
									[
										0,
										15.464
									],
									[
										-15.464,
										0
									]
								],
								o: [
									[
										0,
										15.464
									],
									[
										-15.464,
										0
									],
									[
										0,
										-15.464
									],
									[
										15.464,
										0
									]
								],
								v: [
									[
										28,
										0
									],
									[
										0,
										28
									],
									[
										-28,
										0
									],
									[
										0,
										-28
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.9294117647058824,
								0.06274509803921569,
								0.3843137254901961,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 10,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								53,
								53
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 51,
							s: [
								0
							]
						},
						{
							t: 79,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 39,
							s: [
								0
							]
						},
						{
							t: 64,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 39,
		op: 79,
		st: 39,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "icon",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							-90
						]
					},
					{
						t: 40,
						s: [
							270
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					150,
					75,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					53,
					53,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-15.464
									],
									[
										15.464,
										0
									],
									[
										0,
										15.464
									],
									[
										-15.464,
										0
									]
								],
								o: [
									[
										0,
										15.464
									],
									[
										-15.464,
										0
									],
									[
										0,
										-15.464
									],
									[
										15.464,
										0
									]
								],
								v: [
									[
										28,
										0
									],
									[
										0,
										28
									],
									[
										-28,
										0
									],
									[
										0,
										-28
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.9294117647058824,
								0.06274509803921569,
								0.3843137254901961,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 10,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								53,
								53
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 12,
							s: [
								0
							]
						},
						{
							t: 40,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 25,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 40,
		st: 0,
		bm: 0
	}
];
const markers = [
];
const blockerSpinnerLottieJson = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

const _sfc_main$H = {
  __name: 'LottiePlayer',
  props: [
  'animationJson',
  'autoplay',
  'loop',
],
  setup(__props) {



return (_ctx, _cache) => {
  return (openBlock(), createBlock(unref(Vue3Lottie), {
    class: "h-full w-full",
    "animation-data": __props.animationJson,
    loop: __props.loop,
    autoplay: __props.autoplay
  }, null, 8, ["animation-data", "loop", "autoplay"]))
}
}

};

const _sfc_main$G = {
  __name: 'DSSpinnerBlock',
  props: {
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.SPINNER, props.customThemeObject);
  return componentClasses
});
// const LottiePlayer = defineAsyncComponent(() => import('./../shared/LottiePlayer.vue'))

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", mergeProps({
    "data-ds-component": "spinner",
    class: theme.value.spinnerBlock
  }, _ctx.$attrs), [
    createElementVNode("div", {
      class: normalizeClass(theme.value.spinnerBlockInner)
    }, [
      createVNode(_sfc_main$H, {
        "animation-json": unref(blockerSpinnerLottieJson),
        loop: true,
        autoplay: true
      }, null, 8, ["animation-json"])
    ], 2)
  ], 16))
}
}

};

const _sfc_main$F = /*#__PURE__*/Object.assign({
  inheritAttrs: false,
}, {
  __name: 'DSSpinner',
  props: {
  mode: { type: String, default: 'inline' },
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  setup(__props) {


const props = __props;
const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.SPINNER, props.customThemeObject);
  return componentClasses
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(theme.value.container)
  }, [
    (__props.mode === 'inline')
      ? (openBlock(), createBlock(_sfc_main$T, mergeProps({ key: 0 }, _ctx.$attrs, {
          "custom-theme-object": props.customThemeObject
        }), null, 16, ["custom-theme-object"]))
      : (__props.mode === 'block')
        ? (openBlock(), createBlock(_sfc_main$G, mergeProps({ key: 1 }, _ctx.$attrs, {
            "custom-theme-object": props.customThemeObject
          }), null, 16, ["custom-theme-object"]))
        : createCommentVNode("", true)
  ], 2))
}
}

});

function block0$9 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "No results.": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"No results."}}
      }
    }
  });
}

function block1$5 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "de",
    "resource": {
      "No results.": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Keine Ergebnisse."}}
    }
  });
}

function block2$5 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "es",
    "resource": {
      "No results.": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"No hay resultados."}}
    }
  });
}

function block3$4 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "No results.": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Aucun résultat."}}
    }
  });
}

const _sfc_main$E = /*#__PURE__*/Object.assign({
  inheritAttrs: false,
}, {
  __name: 'DSComboboxInput',
  props: /*#__PURE__*/mergeModels({
  options: { default: undefined },
  placeholder: { default: '' },
  modelValue: { default: undefined },
  queryFunction: { default: undefined },
  customThemeObject: {
    type: Object,
    required: false,
  },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {



const props = __props;
const { t } = useI18n();
const value = useModel(__props, "modelValue");
const query = ref('');
const loadingOptions = ref(false);
const filteredOptions = ref([]);
const popup = ref(null);

const debouncedUpdateFilteredOptions = debounce(async () => {
  filteredOptions.value = await getFilteredOptions();
  loadingOptions.value = false;
}, 500);

function defaultQueryFunction({ options, query }) {
  if (!query)
    return options
  return options.filter(option =>
    (option.label || option)
      .toString()
      .toLowerCase()
      .includes(query.toString().toLowerCase()),
  )
}

function getOptionValue(option) {
  // TODO: support 'by' prop
  return option?.value !== undefined ? option?.value : option
}

function compareValues(a, b) {
  // TODO: support comparator prop
  return safeIsEqual(a, b)
}

function by(a, b) {
  return compareValues(getOptionValue(a), getOptionValue(b))
}

const selectedOption = computed(() => {
  if (value.value === undefined)
    return undefined
  return props.options?.find(option => compareValues(getOptionValue(option), value.value)) || value.value
});

watch(
  query,
  async (val) => {
    loadingOptions.value = true;
    if (val?.length > 0)
      popup?.value?.open();
    debouncedUpdateFilteredOptions();
  },
  { immediate: true },
);

watch(
  value,
  () => {
    if (popup?.value)
      popup.value.close();
  },
  { immediate: true },
);

async function getFilteredOptions() {
  if (props.options && !props.queryFunction)
    return defaultQueryFunction({ options: props.options, query: query.value })

  if (props.queryFunction) {
    return await props.queryFunction({
      options: props.options,
      query: query.value,
    })
  }
  return []
}

function deselect() {
  value.value = undefined;
}

const theme = computed(() => {
  const { componentClasses } = useTheme(
    ThemeTypes.COMBOBOX_INPUT,
    props.customThemeObject,
  );
  return componentClasses
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    "data-ds-component": "combobox-input",
    "data-testid": "ds-combobox-input",
    class: normalizeClass(theme.value.container)
  }, [
    createVNode(unref(Combobox), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((value).value = $event)),
      nullable: "",
      by: by
    }, {
      default: withCtx(() => [
        createVNode(DSPopup, mergeProps({
          ref_key: "popup",
          ref: popup,
          offset: 4,
          placement: "bottom-start",
          "match-width": "",
          enter: theme.value.enter,
          "enter-from": theme.value.enterFrom,
          "enter-to": theme.value.enterTo,
          leave: theme.value.leave,
          "leave-from": theme.value.leaveFrom,
          "leave-to": theme.value.leaveTo,
          middleware: [
          {
            name: 'deep-left',
            fn({ elements, y }) {
              return { x: elements.reference.offsetLeft, y }
            },
          },
        ]
        }, _ctx.$attrs), {
          content: withCtx(() => [
            (!loadingOptions.value)
              ? (openBlock(), createBlock(unref(ComboboxOptions), {
                  key: 0,
                  "data-testid": "ds-combobox-input-menu",
                  static: "",
                  class: normalizeClass(theme.value.menu)
                }, {
                  default: withCtx(() => [
                    (filteredOptions.value?.length === 0)
                      ? (openBlock(), createElementBlock("div", {
                          key: 0,
                          class: normalizeClass(theme.value.noResultLabel)
                        }, toDisplayString(unref(t)('No results.')), 3))
                      : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(filteredOptions.value, (option) => {
                          return (openBlock(), createBlock(unref(ComboboxOption), {
                            key: option.id,
                            as: "template",
                            value: getOptionValue(option)
                          }, {
                            default: withCtx(({ selected, active }) => [
                              createElementVNode("li", {
                                class: normalizeClass({
                    selected,
                    [theme.value.optionItem]: true,
                    [theme.value.optionActive]: active || selected,
                    [theme.value.optionDisabled]:
                      option.unavailable || option.disabled,
                  })
                              }, [
                                createElementVNode("div", {
                                  class: normalizeClass(theme.value.optionCustom)
                                }, [
                                  renderSlot(_ctx.$slots, "custom", mergeProps({ ref_for: true }, { row: option }), () => [
                                    createTextVNode(toDisplayString(option?.label || option), 1)
                                  ])
                                ], 2)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                  ]),
                  _: 3
                }, 8, ["class"]))
              : createCommentVNode("", true)
          ]),
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(theme.value.field)
            }, [
              createElementVNode("div", {
                class: normalizeClass(theme.value.fieldLayout)
              }, [
                (!value.value)
                  ? (openBlock(), createBlock(unref(ComboboxInput), {
                      key: 0,
                      "data-testid": "ds-combobox-input-field",
                      class: normalizeClass(theme.value.input),
                      placeholder: __props.placeholder,
                      onChange: _cache[0] || (_cache[0] = $event => (query.value = $event.target.value || ''))
                    }, null, 8, ["class", "placeholder"]))
                  : createCommentVNode("", true),
                createVNode(unref(ComboboxButton), {
                  "data-testid": "ds-combobox-input-arrow-button",
                  class: normalizeClass(theme.value.chevronDownButton)
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "icon", {}, () => [
                      (loadingOptions.value)
                        ? (openBlock(), createBlock(_sfc_main$F, {
                            key: 0,
                            class: normalizeClass(theme.value.spinner)
                          }, null, 8, ["class"]))
                        : (openBlock(), createBlock(_sfc_main$X, {
                            key: 1,
                            icon: "i-far-chevron-down",
                            size: "18",
                            class: "text-secondary",
                            "aria-hidden": "true"
                          }))
                    ])
                  ]),
                  _: 3
                }, 8, ["class"])
              ], 2),
              (selectedOption.value)
                ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    "data-testid": "ds-combobox-input-value-box",
                    class: normalizeClass(theme.value.valueBox)
                  }, [
                    createElementVNode("div", {
                      class: normalizeClass(theme.value.valueBoxLabel)
                    }, [
                      renderSlot(_ctx.$slots, "custom", normalizeProps(guardReactiveProps({ row: selectedOption.value })), () => [
                        createTextVNode(toDisplayString(selectedOption.value?.label || selectedOption.value || ''), 1)
                      ])
                    ], 2),
                    createElementVNode("button", {
                      class: normalizeClass(theme.value.closeButton),
                      "data-testid": "ds-combobox-input-close-button",
                      onClick: withModifiers(deselect, ["stop"])
                    }, [
                      createVNode(_sfc_main$X, {
                        icon: "i-far-xmark",
                        size: "18"
                      })
                    ], 2)
                  ], 2))
                : createCommentVNode("", true)
            ], 2)
          ]),
          _: 3
        }, 16, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to", "middleware"])
      ]),
      _: 3
    }, 8, ["modelValue"])
  ], 2))
}
}

});
if (typeof block0$9 === 'function') block0$9(_sfc_main$E);
if (typeof block1$5 === 'function') block1$5(_sfc_main$E);
if (typeof block2$5 === 'function') block2$5(_sfc_main$E);
if (typeof block3$4 === 'function') block3$4(_sfc_main$E);

const _sfc_main$D = {
  __name: 'DSCssVariables',
  props: {
  theme: { type: Object, required: true },
},
  setup(__props) {

const props = __props;

useDeprecated({ suggestedComponent: 'DSThemeProvider' });

const flatThemeArray = computed(() => {
  if (!props.theme)
    return []
  const flatObj = flatten(props.theme, { safe: true });
  const transformedObj = Object.keys(flatObj).reduce((obj, key) => {
    const newKey = key
      .replaceAll('.', '-')
      .replace('-DEFAULT', '')
      .replace(/([A-Z])/g, '-$1')
      .toLowerCase();
    obj[newKey] = Array.isArray(flatObj[key]) ? flatObj[key].join(', ') : flatObj[key];
    return obj
  }, {});
  return Object.entries(transformedObj)
});

return (_ctx, _cache) => {
  return (openBlock(), createBlock(resolveDynamicComponent("style"), null, {
    default: withCtx(() => [
      createTextVNode(" :root { "),
      (openBlock(true), createElementBlock(Fragment, null, renderList(flatThemeArray.value, (row) => {
        return (openBlock(), createElementBlock(Fragment, null, [
          createTextVNode(toDisplayString('\r\n\t\t') + " --" + toDisplayString(row[0]) + ": " + toDisplayString(row[1]) + "; ", 1)
        ], 64))
      }), 256)),
      createTextVNode(" " + toDisplayString('\r\n') + " } " + toDisplayString('\r\n'))
    ]),
    _: 1
  }))
}
}

};

const _hoisted_1$i = ["disabled"];
const _hoisted_2$6 = { class: "sr-only" };
const _hoisted_3$2 = ["onClick"];
const _hoisted_4$1 = ["disabled"];
const _hoisted_5 = { class: "sr-only" };


const _sfc_main$C = {
  __name: 'DSDataPager',
  props: {
  customThemeObject: {
    type: Object,
    required: false,
  },
  maxVisibleButtons: {
    type: Number,
    default: 3,
  },
},
  setup(__props) {

const props = __props;

const dataQueryStore = inject('data-query-store');

const { t } = useI18n();
const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.DATAPAGER, props.customThemeObject);
  return componentClasses
});

const currentPage = toRef(() => dataQueryStore.value.state.value.pagination?.currentPage);
const totalPages = computed(() => {
  if (dataQueryStore.value.state.value.pagination?.totalPages !== undefined)
    return dataQueryStore.value.state.value.pagination.totalPages
  const perPage = dataQueryStore.value.state.value.pagination?.perPage;
  const count = dataQueryStore.value.state.value.pagination?.count;
  if (perPage && count)
    return Math.ceil(count / perPage)
  else return 1
});

const startPage = computed(() => {
  const pagesBeforeCurrent = Math.floor(props.maxVisibleButtons / 2);
  return Math.max(1, currentPage.value - pagesBeforeCurrent)
});

const endPage = computed(() =>
  Math.min(
    startPage.value + props.maxVisibleButtons - 1,
    totalPages.value,
  ),
);

const pages = computed(() => {
  const range = [];

  for (let i = startPage.value; i <= endPage.value; i += 1) {
    range.push({
      name: i,
      isDisabled: i === currentPage.value,
    });
  }

  return range
});

const isInFirstPage = computed(() => {
  return currentPage.value === 1
});

const isInLastPage = computed(() => {
  return currentPage.value >= totalPages.value
});

function onClickPreviousPage() {
  changePage(currentPage.value - 1);
}

function onClickPage(page) {
  changePage(page);
}

function onClickNextPage() {
  changePage(currentPage.value + 1);
}

function isPageActive(page) {
  return currentPage.value === page
}

function changePage(page) {
  dataQueryStore.value.actions.updatePage(page);
}

return (_ctx, _cache) => {
  return (endPage.value > 1)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(theme.value.container)
      }, [
        createElementVNode("ul", {
          class: normalizeClass(theme.value.dataPagerList)
        }, [
          createElementVNode("li", {
            class: normalizeClass(theme.value.dataPagerListItem)
          }, [
            createElementVNode("button", {
              type: "button",
              disabled: isInFirstPage.value,
              class: normalizeClass({ 'cursor-not-allowed': isInFirstPage.value, [theme.value.dataPagerFirstPageButton]: true }),
              onClick: onClickPreviousPage
            }, [
              createVNode(_sfc_main$X, {
                icon: theme.value.dataPagerChevronLeft
              }, null, 8, ["icon"]),
              createElementVNode("div", _hoisted_2$6, toDisplayString(unref(t)('Previous')), 1)
            ], 10, _hoisted_1$i)
          ], 2),
          (openBlock(true), createElementBlock(Fragment, null, renderList(pages.value, (page) => {
            return (openBlock(), createElementBlock("li", {
              key: page.name,
              class: normalizeClass(theme.value.dataPagerListItem)
            }, [
              (isPageActive(page.name))
                ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: normalizeClass(theme.value.dataPagerPageLabel)
                  }, toDisplayString(page.name), 3))
                : (openBlock(), createElementBlock("a", {
                    key: 1,
                    class: normalizeClass(theme.value.dataPagerPageLink),
                    href: "#",
                    role: "button",
                    onClick: withModifiers($event => (onClickPage(page.name)), ["prevent"])
                  }, toDisplayString(page.name), 11, _hoisted_3$2))
            ], 2))
          }), 128)),
          createElementVNode("li", {
            class: normalizeClass(theme.value.dataPagerListItem)
          }, [
            createElementVNode("button", {
              type: "button",
              disabled: isInLastPage.value,
              class: normalizeClass({ 'cursor-not-allowed': isInLastPage.value, [theme.value.dataPagerLastPageButton]: true }),
              onClick: onClickNextPage
            }, [
              createVNode(_sfc_main$X, {
                icon: theme.value.dataPagerChevronRight
              }, null, 8, ["icon"]),
              createElementVNode("div", _hoisted_5, toDisplayString(unref(t)('Next')), 1)
            ], 10, _hoisted_4$1)
          ], 2)
        ], 2)
      ], 2))
    : createCommentVNode("", true)
}
}

};

function block0$8 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Showing { start } to { end } of { length }": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"Showing "},{"t":4,"k":"start"},{"t":3,"v":" to "},{"t":4,"k":"end"},{"t":3,"v":" of "},{"t":4,"k":"length"}]}}
      }
    }
  });
}

function block1$4 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "de",
    "resource": {
      "Showing { start } to { end } of { length }": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"Anzeige von "},{"t":4,"k":"start"},{"t":3,"v":" bis "},{"t":4,"k":"end"},{"t":3,"v":" von "},{"t":4,"k":"length"}]}}
    }
  });
}

function block2$4 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "es",
    "resource": {
      "Showing { start } to { end } of { length }": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"Mostrando de "},{"t":4,"k":"start"},{"t":3,"v":" a "},{"t":4,"k":"end"},{"t":3,"v":" sobre "},{"t":4,"k":"length"}]}}
    }
  });
}

function block3$3 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "Showing { start } to { end } of { length }": {"t":0,"b":{"t":2,"i":[{"t":3,"v":"Affichage de "},{"t":4,"k":"start"},{"t":3,"v":" à "},{"t":4,"k":"end"},{"t":3,"v":" sur "},{"t":4,"k":"length"}]}}
    }
  });
}

const _hoisted_1$h = ["innerHTML"];


const _sfc_main$B = {
  __name: 'DSDataPagerSummary',
  props: {
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.DATAPAGER_SUMMARY, props.customThemeObject);
  return componentClasses
});

const dataQueryStore = inject('data-query-store');

const length = toRef(() => dataQueryStore.value.state.value.pagination?.count);
const currentPage = toRef(() => dataQueryStore.value.state.value.pagination?.currentPage);
const perPage = toRef(() => dataQueryStore.value.state.value.pagination?.perPage);

const start = computed(() => (currentPage.value - 1) * perPage.value);
const end = computed(() => {
  return start.value < length.value
    ? Math.min(start.value + perPage.value, length.value)
    : start.value + perPage.value
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("p", {
    class: normalizeClass(theme.value.container),
    innerHTML: 
      unref(t)('Showing { start } to { end } of { length }', {
        start: `<span class='${theme.value.dataPagerSummaryText}'>${length.value > 0 ? start.value + 1 : 0}</span>`,
        end: `<span class='${theme.value.dataPagerSummaryText}'>${length.value > 0 ? end.value : 0}</span>`,
        length: `<span class='${theme.value.dataPagerSummaryText}'>${length.value}</span>`,
      })
    
  }, null, 10, _hoisted_1$h))
}
}

};
if (typeof block0$8 === 'function') block0$8(_sfc_main$B);
if (typeof block1$4 === 'function') block1$4(_sfc_main$B);
if (typeof block2$4 === 'function') block2$4(_sfc_main$B);
if (typeof block3$3 === 'function') block3$3(_sfc_main$B);

function block0$7 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "And": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"And"}},
        "Date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Date"}},
        "Days": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Days"},{"t":2,"i":[{"t":3}],"s":"Day"},{"t":2,"i":[{"t":3}],"s":"Days"}]}},
        "Is after": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is after"}},
        "Is any date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is any date"}},
        "Is All Dates": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is All Dates"}},
        "Is before": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is before"}},
        "Is between": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is between"}},
        "Is in the last": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is in the last"}},
        "Is on or after": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is on or after"}},
        "Is on or before": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is on or before"}},
        "Is on": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Is on"}},
        "Months": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Months"},{"t":2,"i":[{"t":3}],"s":"Month"},{"t":2,"i":[{"t":3}],"s":"Months"}]}},
        "Weeks": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Weeks"},{"t":2,"i":[{"t":3}],"s":"Week"},{"t":2,"i":[{"t":3}],"s":"Weeks"}]}},
        "Years": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Years"},{"t":2,"i":[{"t":3}],"s":"Year"},{"t":2,"i":[{"t":3}],"s":"Years"}]}}
      }
    }
  });
}

function block1$3 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "de",
    "resource": {
      "And": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Und"}},
      "Date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Datum"}},
      "Days": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Tage"},{"t":2,"i":[{"t":3}],"s":"Tag"},{"t":2,"i":[{"t":3}],"s":"Tage"}]}},
      "Is after": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Ist nach"}},
      "Is All Dates": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Ist alle Daten"}},
      "Is before": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Ist vor"}},
      "Is between": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Ist zwischen"}},
      "Is in the last": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Ist in der letzten"}},
      "Is on or after": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Ist am oder nach"}},
      "Is on or before": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Ist am oder vor"}},
      "Is on": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Ist am"}},
      "Months": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Monate"},{"t":2,"i":[{"t":3}],"s":"Monat"},{"t":2,"i":[{"t":3}],"s":"Monate"}]}},
      "Weeks": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Wochen"},{"t":2,"i":[{"t":3}],"s":"Woche"},{"t":2,"i":[{"t":3}],"s":"Wochen"}]}},
      "Years": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Jahre"},{"t":2,"i":[{"t":3}],"s":"Jahr"},{"t":2,"i":[{"t":3}],"s":"Jahre"}]}},
      "Is any date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Beliebiges Datum"}}
    }
  });
}

function block2$3 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "And": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Et"}},
      "Date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Date"}},
      "Days": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Jour"},{"t":2,"i":[{"t":3}],"s":"Jour"},{"t":2,"i":[{"t":3}],"s":"Jours"}]}},
      "Is after": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est après"}},
      "Is All Dates": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est Toutes les dates"}},
      "Is before": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est avant"}},
      "Is between": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est entre"}},
      "Is in the last": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est dans les derniers"}},
      "Is on or after": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est le ou après"}},
      "Is on or before": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est le ou avant"}},
      "Is on": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est le"}},
      "Months": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Mois"},{"t":2,"i":[{"t":3}],"s":"Mois"},{"t":2,"i":[{"t":3}],"s":"Mois"}]}},
      "Weeks": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Semaine"},{"t":2,"i":[{"t":3}],"s":"Semaine"},{"t":2,"i":[{"t":3}],"s":"Semaines"}]}},
      "Years": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Année"},{"t":2,"i":[{"t":3}],"s":"Année"},{"t":2,"i":[{"t":3}],"s":"Années"}]}},
      "Is any date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Est n’importe quelle date"}}
    }
  });
}

function block3$2 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "es",
    "resource": {
      "And": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Y"}},
      "Date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Fecha"}},
      "Days": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Días"},{"t":2,"i":[{"t":3}],"s":"Día"},{"t":2,"i":[{"t":3}],"s":"Días"}]}},
      "Is after": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Es posterior a"}},
      "Is All Dates": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Es todas las fechas"}},
      "Is before": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Es anterior a"}},
      "Is between": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Está entre"}},
      "Is in the last": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Es en el último"}},
      "Is on or after": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Es en o posterior a"}},
      "Is on or before": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Es en o anterior a"}},
      "Is on": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Es en"}},
      "Months": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Meses"},{"t":2,"i":[{"t":3}],"s":"Mes"},{"t":2,"i":[{"t":3}],"s":"Meses"}]}},
      "Weeks": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Semanas"},{"t":2,"i":[{"t":3}],"s":"Semana"},{"t":2,"i":[{"t":3}],"s":"Semanas"}]}},
      "Years": {"t":0,"b":{"t":1,"c":[{"t":2,"i":[{"t":3}],"s":"Años"},{"t":2,"i":[{"t":3}],"s":"Año"},{"t":2,"i":[{"t":3}],"s":"Años"}]}},
      "Is any date": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Es cualquier fecha"}}
    }
  });
}

const _hoisted_1$g = { key: 2 };


const _sfc_main$A = {
  __name: 'RangeForm',
  props: {
  modelValue: {},
  hideShowAllOption: Boolean,
},
  emits: [
  'update:formState',
  'update:modelValue',
  'valid',
  'invalid',
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t, d, locale } = useI18n();
const dayjs = useDayjs();

const form = ref({
  selectedRange: {
    label: !props.hideShowAllOption ? t('Is any date') : t('Is in the last'),
    value: !props.hideShowAllOption ? 'is any date' : 'is in the last',
  },
  rangeNum: undefined,
  selectedRangeUnit: { label: t('Days', 0), value: 'day' },
  rangeStart: undefined,
  rangeEnd: undefined,
});

const initializing = ref(false);

const dateError = computed(() => {
  if (
    [
      'is on',
      'is after',
      'is on or after',
      'is before',
      'is on or before',
    ].includes(form.value?.selectedRange?.value)
  )
    return !form.value.rangeStart
  if (form.value?.selectedRange?.value === 'is between') {
    // if (!form.value.rangeStart && !form.value.rangeEnd) return true
    return dayjs.value(form.value.rangeStart).isAfter(form.value.rangeEnd)
  }
  return false
});

const rangeOptions = computed(() => {
  return [
    ...(!props.hideShowAllOption
      ? [{ label: t('Is any date'), value: 'is any date' }]
      : []),
    { label: t('Is in the last'), value: 'is in the last' },
    { label: t('Is between'), value: 'is between' },
    { label: t('Is after'), value: 'is after' },
    { label: t('Is on or after'), value: 'is on or after' },
    { label: t('Is on'), value: 'is on' },
    { label: t('Is on or before'), value: 'is on or before' },
    { label: t('Is before'), value: 'is before' },
  ].map(o => ({
    value: { ...o },
    label: o.label,
  }))
});

const rangeUnitOptions = computed(() => {
  return [
    { label: t('Days', form.value.rangeNum || 0), value: 'day' },
    { label: t('Weeks', form.value.rangeNum || 0), value: 'week' },
    { label: t('Months', form.value.rangeNum || 0), value: 'month' },
    { label: t('Years', form.value.rangeNum || 0), value: 'year' },
  ].map(o => ({
    value: { ...o },
    label: o.label,
  }))
});

const displayValueEnding = ref(() => {
  if (!form.value)
    return ''
  switch (form.value?.selectedRange?.value) {
    case 'is any date':
      return ''
    case 'is in the last':
      return `${form.value.rangeNum || 0} ${
      form.value?.selectedRangeUnit.label
    }`
    case 'is between':
      return `${
      form.value.rangeStart
        ? d(`${form.value.rangeStart}T00:00`, 'medium')
        : '-'
    } - ${
      form.value.rangeEnd ? d(`${form.value.rangeEnd}T23:59`, 'medium') : '-'
    }`
  }
  if (!form.value.rangeStart)
    return ''
  return d(`${form.value.rangeStart}T00:00`, 'medium')
});

const rangeValue = computed(() => {
  switch (form.value?.selectedRange?.value) {
    case 'is in the last':
      return {
        gte: dayjs
          .value()
          .subtract(
            form.value.rangeNum || 0,
            form.value?.selectedRangeUnit?.value,
          )
          .add(1, 'day')
          .format('YYYY-MM-DD'),
        lte: dayjs.value().format('YYYY-MM-DD'),
      }
    case 'is between':
      return {
        gte:
          form.value.rangeStart?.length > 0 ? form.value.rangeStart : undefined,
        lte: form.value.rangeEnd?.length > 0 ? form.value.rangeEnd : undefined,
      }
    case 'is after':
      return {
        gte: dayjs
          .value(form.value.rangeStart)
          .add(1, 'day')
          .format('YYYY-MM-DD'),
      }
    case 'is on or after':
      return { gte: form.value.rangeStart }
    case 'is on':
      return { gte: form.value.rangeStart, lte: form.value.rangeStart }
    case 'is on or before':
      return { lte: form.value.rangeStart }
    case 'is before':
      return {
        lte: dayjs
          .value(form.value.rangeStart)
          .subtract(1, 'day')
          .format('YYYY-MM-DD'),
      }
    case 'is any date':
    default:
      return undefined
  }
});

const rangeValuePreset = computed(() => {
  switch (form.value?.selectedRange?.value) {
    case 'is in the last':
      return `past_${form.value.rangeNum || 0}_${
      form.value?.selectedRangeUnit?.value
    }${form.value.rangeNum === 1 ? '' : 's'}`
    default:
      return undefined
  }
});

const currentValue = computed(() => {
  if (!rangeValue.value)
    return
  return { ...rangeValue.value, timeframe: rangeValuePreset.value }
});

const formState = computed(() => {
  return {
    label: `${form.value?.selectedRange?.label}${
      displayValueEnding.value ? ` ${displayValueEnding.value}` : ''
    }`,
    string: {
      range: form.value?.selectedRange?.label,
      detail: displayValueEnding.value,
    },
    state: currentValue.value,
    value: rangeValue.value,
  }
});

function initializeValue() {
  initializing.value = true;
  if (props.modelValue?.timeframe) {
    // timeframe: past_year, any_time
    if (props.modelValue.timeframe !== 'any_time') {
      const { gte, lte, timeframe, rangeNum, rangeUnit }
        = generateTimeRange(props.modelValue.timeframe);
      form.value.rangeNum = rangeNum;
      form.value.rangeStart = gte;
      form.value.rangeEnd = lte;
      form.value.selectedRangeUnit = rangeUnitOptions.value.find(
        o => o.value === rangeUnit,
      );

      if (
        props.modelValue.timeframe.includes('past')
        || props.modelValue.timeframe.includes('last')
      ) {
        form.value.selectedRange = rangeOptions.value.find(
          o => o.value === 'is in the last',
        );
      }
      else if (
        props.modelValue.timeframe.includes('this')
        || props.modelValue.timeframe.includes('current')
      ) {
        form.value.selectedRange = rangeOptions.value.find(
          o => o.value === 'is between',
        );
      }
    }
  }
  else if (props.modelValue) {
    if (props.modelValue?.gte && props.modelValue?.lte) {
      if (props.modelValue.gte === props.modelValue.lte) {
        form.value.selectedRange = rangeOptions.value.find(
          o => o.value === 'is on',
        );
      }
      else {
        form.value.selectedRange = rangeOptions.value.find(
          o => o.value === 'is between',
        );
      }
    }
    else if (props.modelValue?.gte) {
      form.value.selectedRange = rangeOptions.value.find(
        o => o.value === 'is on or after',
      );
    }
    else {
      form.value.selectedRange = rangeOptions.value.find(
        o => o.value === 'is on or before',
      );
      form.value.rangeStart = props.modelValue.lte;
      initializing.value = false;
      return
    }
    form.value.rangeStart = props.modelValue.gte;
    form.value.rangeEnd = props.modelValue.lte;
  }
  else {
    form.value.selectedRange = rangeOptions.value.find(
      o => o.value === 'is any date',
    );
  }
  initializing.value = false;
}

function updateModelValue() {
  emit('update:modelValue', deepCopy(currentValue.value));
}

function updateFormState() {
  emit('update:formState', deepCopy(formState.value));
}

watch(rangeValue, () => {
  if (initializing.value || safeIsEqual(currentValue.value, props.modelValue))
    return
  updateModelValue();
});

watch(dateError, (error) => {
  if (error)
    emit('invalid');
  else emit('valid');
});

watch(
  () => props.modelValue,
  () => {
    if (safeIsEqual(currentValue.value, props.modelValue))
      return
    initializeValue();
  },
  { immediate: true },
);

watch(
  form,
  () => {
    updateFormState();
  },
  {
    immediate: true,
    deep: true,
  },
);

watch(locale, () => {
  nextTick(() => updateFormState());
});

const theme = computed(() => {
  const { componentClasses } = useTheme(
    ThemeTypes.DATE_RANGE_INPUT,
  );
  return componentClasses
});

return (_ctx, _cache) => {
  const _component_FormKit = resolveComponent("FormKit");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(theme.value.rangeForm),
    "data-ds-component": "date-range-form",
    "data-testid": "ds-date-range-form"
  }, [
    createVNode(DSListboxInput, {
      modelValue: form.value.selectedRange,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.value.selectedRange) = $event)),
      "data-testid": "range-timeframe-listbox",
      options: rangeOptions.value,
      deselect: false,
      class: "w-full"
    }, null, 8, ["modelValue", "options"]),
    (form.value.selectedRange?.value !== 'is any date')
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (form.value.selectedRange?.value === 'is in the last')
            ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(theme.value.rangeFormLast)
              }, [
                createElementVNode("div", {
                  class: normalizeClass(theme.value.rangeFormLastQuantityWrapper)
                }, [
                  createVNode(_component_FormKit, {
                    modelValue: form.value.rangeNum,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((form.value.rangeNum) = $event)),
                    modelModifiers: { number: true },
                    type: "number",
                    "data-testid": "range-number-input",
                    min: 0,
                    max: 999
                  }, null, 8, ["modelValue"])
                ], 2),
                createVNode(DSListboxInput, {
                  modelValue: form.value.selectedRangeUnit,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((form.value.selectedRangeUnit) = $event)),
                  "data-testid": "range-unit-listbox",
                  options: rangeUnitOptions.value,
                  deselect: false,
                  "options-class": theme.value.rangeFormLastUnitOptions,
                  class: normalizeClass(theme.value.rangeFormLastUnit)
                }, null, 8, ["modelValue", "options", "options-class", "class"])
              ], 2))
            : (form.value.selectedRange?.value === 'is between')
              ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: normalizeClass(theme.value.rangeFormBetween)
                }, [
                  createVNode(DSDateCalendarInput, {
                    modelValue: form.value.rangeStart,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((form.value.rangeStart) = $event)),
                    "data-testid": "range-start-input",
                    class: normalizeClass([
            theme.value.rangeFormBetweenCalendarInput,
            { [theme.value.rangeFormBetweenCalendarInputError]: dateError.value },
          ])
                  }, null, 8, ["modelValue", "class"]),
                  createElementVNode("div", {
                    class: normalizeClass(theme.value.rangeFormBetweenAnd)
                  }, toDisplayString(unref(t)('And')), 3),
                  createVNode(DSDateCalendarInput, {
                    modelValue: form.value.rangeEnd,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((form.value.rangeEnd) = $event)),
                    "data-testid": "range-end-input",
                    class: normalizeClass([
            theme.value.rangeFormBetweenCalendarInput,
            { [theme.value.rangeFormBetweenCalendarInputError]: dateError.value },
          ])
                  }, null, 8, ["modelValue", "class"])
                ], 2))
              : (openBlock(), createElementBlock("div", _hoisted_1$g, [
                  createVNode(DSDateCalendarInput, {
                    modelValue: form.value.rangeStart,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((form.value.rangeStart) = $event)),
                    "data-testid": "range-start-input"
                  }, null, 8, ["modelValue"])
                ]))
        ], 64))
      : createCommentVNode("", true)
  ], 2))
}
}

};
if (typeof block0$7 === 'function') block0$7(_sfc_main$A);
if (typeof block1$3 === 'function') block1$3(_sfc_main$A);
if (typeof block2$3 === 'function') block2$3(_sfc_main$A);
if (typeof block3$2 === 'function') block3$2(_sfc_main$A);

function block0$6 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Apply": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Apply"}},
        "Any Time": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Any Time"}}
      }
    }
  });
}

function block1$2 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "de",
    "resource": {
      "Apply": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Anwenden"}},
      "Any Time": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Beliebige Zeit"}}
    }
  });
}

function block2$2 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "Apply": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Appliquer"}},
      "Any Time": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"N’importe quel moment"}}
    }
  });
}

function block3$1 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "es",
    "resource": {
      "Apply": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Aplicar"}},
      "Any Time": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Cualquier hora"}}
    }
  });
}

const _hoisted_1$f = {
  "data-ds-component": "date-range-input",
  "data-testid": "ds-date-range-input"
};
const _hoisted_2$5 = ["disabled"];


const _sfc_main$z = {
  __name: 'DSDateRangeInput',
  props: {
  modelValue: {},
  name: { default: 'Date' },
  formState: {},
  hideShowAllOption: Boolean,
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  emits: ['update:modelValue', 'update:formState', 'apply'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t, locale } = useI18n();

const value = ref();
const isValid = ref(true);
const tempFormState = ref(props.formState);
const popup = ref(null);

const displayValue = computed(() => {
  if (
    !tempFormState.value?.string
    || tempFormState.value.string?.range?.toLowerCase() === 'is any date'
  )
    return t('Any Time')
  else return tempFormState.value?.string?.range
});

const displayValueDetail = computed(() => {
  return tempFormState.value?.string?.detail
});

const isDirty = computed(() => {
  return !safeIsEqual(props.modelValue, value.value)
});

watch(
  () => props.modelValue,
  async (newVal) => {
    if (safeIsEqual(newVal, value.value))
      return
    value.value = deepCopy(newVal);
  },
);

watch(
  value,
  (newVal) => {
    if (!safeIsEqual(newVal, props.modelValue))
      return
    nextTick(() => apply());
  },
  { immediate: true, deep: true },
);

watch(locale, () => {
  nextTick(() => apply());
});

onMounted(() => {
  nextTick(() => apply());
});

function close() {
  popup.value?.close();
}

function apply() {
  emit('update:modelValue', deepCopy(value.value));
  emit('update:formState', tempFormState.value);
  emit('apply');
  close();
}

// TODO: update this to reset value on open
function onOpen() {}

const theme = computed(() => {
  const { componentClasses } = useTheme(
    ThemeTypes.DATE_RANGE_INPUT,
    props.customThemeObject,
  );
  return componentClasses
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$f, [
    createVNode(DSPopup, {
      ref_key: "popup",
      ref: popup,
      offset: 4,
      "use-show": "",
      placement: "bottom-start",
      "enter-active": theme.value.enterActive,
      "enter-from": theme.value.enterFrom,
      "enter-to": theme.value.enterTo,
      "leave-active": theme.value.leaveActive,
      "leave-from": theme.value.leaveFrom,
      "leave-to": theme.value.leaveTo,
      onOpen: onOpen
    }, {
      content: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(theme.value.menu),
          "data-testid": "range-form-menu"
        }, [
          createElementVNode("div", {
            class: normalizeClass(theme.value.menuLayout)
          }, [
            createElementVNode("div", {
              class: normalizeClass(theme.value.menuName)
            }, toDisplayString(__props.name), 3),
            renderSlot(_ctx.$slots, "default"),
            createVNode(_sfc_main$A, {
              modelValue: value.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((value).value = $event)),
              "form-state": tempFormState.value,
              "onUpdate:formState": _cache[1] || (_cache[1] = $event => ((tempFormState).value = $event)),
              "hide-show-all-option": __props.hideShowAllOption,
              onInvalid: _cache[2] || (_cache[2] = $event => (isValid.value = false)),
              onValid: _cache[3] || (_cache[3] = $event => (isValid.value = true))
            }, null, 8, ["modelValue", "form-state", "hide-show-all-option"]),
            createElementVNode("button", {
              class: normalizeClass(theme.value.applyButton),
              disabled: !isDirty.value || !isValid.value,
              "data-testid": "range-apply-button",
              onClick: apply
            }, toDisplayString(unref(t)('Apply')), 11, _hoisted_2$5)
          ], 2)
        ], 2)
      ]),
      default: withCtx(() => [
        createElementVNode("button", mergeProps(_ctx.$attrs, {
          class: "rounded",
          "data-testid": "range-open-button"
        }), [
          createElementVNode("div", {
            class: normalizeClass(theme.value.openButton)
          }, [
            createVNode(_sfc_main$X, {
              icon: "i-far-calendar",
              size: "18",
              class: "m-1 text-secondary-300"
            }),
            createElementVNode("span", {
              class: normalizeClass(theme.value.displayValue)
            }, toDisplayString(displayValue.value), 3),
            createVNode(_sfc_main$X, {
              icon: "i-far-chevron-down",
              size: "18",
              class: "m-1 text-text-400"
            })
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(theme.value.displayValueDetail)
          }, toDisplayString(displayValueDetail.value), 3)
        ], 16)
      ]),
      _: 3
    }, 8, ["enter-active", "enter-from", "enter-to", "leave-active", "leave-from", "leave-to"])
  ]))
}
}

};
if (typeof block0$6 === 'function') block0$6(_sfc_main$z);
if (typeof block1$2 === 'function') block1$2(_sfc_main$z);
if (typeof block2$2 === 'function') block2$2(_sfc_main$z);
if (typeof block3$1 === 'function') block3$1(_sfc_main$z);

const _hoisted_1$e = { key: 0 };
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "DSDebugInfo",
  props: {
    spreadValues: { type: Boolean, default: false },
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.DEBUG_INFO, props.customThemeObject);
      return componentClasses;
    });
    const enabled = ref([]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(theme.value.container)
      }, [
        createElementVNode("div", {
          class: normalizeClass(theme.value.debugInfoTitle)
        }, " DEBUG ", 2),
        createElementVNode("div", {
          class: normalizeClass(theme.value.debugInfoOptions)
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(Object.entries(_ctx.$attrs), ([key]) => {
            return openBlock(), createElementBlock("div", {
              key,
              class: normalizeClass(theme.value.debugInfoSingleOption)
            }, [
              createElementVNode("label", {
                class: normalizeClass(theme.value.debugInfoSingleOptionLabel)
              }, [
                createVNode(_sfc_main$Z, {
                  modelValue: enabled.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => enabled.value = $event),
                  value: key
                }, null, 8, ["modelValue", "value"]),
                createElementVNode("span", null, toDisplayString(key), 1)
              ], 2)
            ], 2);
          }), 128))
        ], 2),
        (openBlock(true), createElementBlock(Fragment, null, renderList(Object.entries(_ctx.$attrs), ([key, value]) => {
          return openBlock(), createElementBlock(Fragment, { key }, [
            enabled.value.includes(key) ? (openBlock(), createElementBlock("div", _hoisted_1$e, [
              createElementVNode("span", {
                class: normalizeClass(theme.value.debugInfoDisplayedValues)
              }, toDisplayString(key) + ":", 3),
              createTextVNode(),
              createElementVNode("span", {
                class: normalizeClass({ "whitespace-pre": props.spreadValues })
              }, toDisplayString(value), 3)
            ])) : createCommentVNode("", true)
          ], 64);
        }), 128))
      ], 2);
    };
  }
});

const _hoisted_1$d = ["aria-label", "onClick"];
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "DSDropdown",
  props: {
    as: { default: "template" },
    label: {},
    omitPositionRelative: { type: Boolean, default: false },
    menuItemsClasses: {},
    shift: { type: Boolean, default: true },
    placement: { default: "bottom-start" },
    flip: { type: Boolean, default: true },
    offset: { default: 4 },
    options: {},
    middleware: {},
    customThemeObject: {}
  },
  emits: ["open", "close"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.DROPDOWN, props.customThemeObject);
      return componentClasses;
    });
    const floatingAs = computed(() => {
      return props.as === "div" ? "template" : void 0;
    });
    const { t } = useI18n();
    const isOpen = ref(false);
    watch(
      isOpen,
      (val) => {
        if (val)
          emit("open");
        else
          emit("close");
      }
    );
    function toggleOpen() {
      isOpen.value = !isOpen.value;
    }
    function close() {
      isOpen.value = false;
    }
    __expose({
      close
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(OnClickOutside), { onTrigger: close }, {
        default: withCtx(() => [
          createElementVNode("div", {
            "data-ds-component": "dropdown",
            "data-testid": "ds-dropdown",
            class: normalizeClass({
              relative: !_ctx.omitPositionRelative,
              [theme.value.container]: true
            })
          }, [
            createVNode(unref(Menu), null, {
              default: withCtx(() => [
                createVNode(unref(Float), {
                  as: _ctx.as,
                  "floating-as": floatingAs.value,
                  placement: _ctx.placement,
                  shift: _ctx.shift,
                  show: isOpen.value,
                  flip: _ctx.flip,
                  offset: _ctx.offset,
                  middleware: _ctx.middleware,
                  "vue-transition": "",
                  "transition-type": "transition"
                }, {
                  default: withCtx(() => [
                    createVNode(unref(MenuButton), mergeProps(_ctx.$attrs, {
                      "data-testid": "ds-dropdown-button",
                      class: { open: isOpen.value, [theme.value.dropdownMenuButton]: true },
                      role: "button",
                      "aria-label": unref(t)("Button"),
                      onClick: toggleOpen,
                      onKeyup: withKeys(toggleOpen, ["enter"])
                    }), {
                      default: withCtx(() => [
                        createElementVNode("div", {
                          id: "button",
                          class: normalizeClass(theme.value.dropdownLabelSlot)
                        }, [
                          renderSlot(_ctx.$slots, "label", {}, () => [
                            createTextVNode(toDisplayString(_ctx.label), 1)
                          ])
                        ], 2),
                        renderSlot(_ctx.$slots, "icon", {}, () => [
                          createElementVNode("div", {
                            class: normalizeClass(theme.value.dropdownIconSlot),
                            "aria-hidden": "true"
                          }, null, 2)
                        ])
                      ]),
                      _: 3
                    }, 16, ["class", "aria-label"]),
                    createVNode(Transition, {
                      "enter-active-class": theme.value.dropdownEnterActive,
                      "enter-from-class": theme.value.dropdownEnterFrom,
                      "enter-to-class": theme.value.dropdownEnterTo,
                      "leave-active-class": theme.value.dropdownLeaveActive,
                      "leave-from-class": theme.value.dropdownLeaveFrom,
                      "leave-to-class": theme.value.dropdownLeaveTo
                    }, {
                      default: withCtx(() => [
                        withDirectives(createElementVNode("div", {
                          class: normalizeClass(theme.value.dropdownContent)
                        }, [
                          createElementVNode("div", {
                            "data-testid": "ds-dropdown-menu",
                            class: normalizeClass([_ctx.menuItemsClasses, theme.value.dropdownList])
                          }, [
                            renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ close })), () => [
                              createVNode(unref(MenuItems), {
                                class: normalizeClass(theme.value.dropdownMenuItems),
                                onClick: close
                              }, {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option) => {
                                    return openBlock(), createBlock(unref(MenuItem), {
                                      key: option.label
                                    }, {
                                      default: withCtx(({ active }) => [
                                        createElementVNode("button", {
                                          class: normalizeClass({ [theme.value.dropdownMenuItemActive]: active, [theme.value.dropdownMenuSingleItem]: true }),
                                          "data-testid": "ds-dropdown-menu-item",
                                          "aria-label": option.label,
                                          tabindex: "0",
                                          onClick: option.action
                                        }, toDisplayString(option.label), 11, _hoisted_1$d)
                                      ]),
                                      _: 2
                                    }, 1024);
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ])
                          ], 2)
                        ], 2), [
                          [vShow, isOpen.value]
                        ])
                      ]),
                      _: 3
                    }, 8, ["enter-active-class", "enter-from-class", "enter-to-class", "leave-active-class", "leave-from-class", "leave-to-class"])
                  ]),
                  _: 3
                }, 8, ["as", "floating-as", "placement", "shift", "show", "flip", "offset", "middleware"])
              ]),
              _: 3
            })
          ], 2)
        ]),
        _: 3
      });
    };
  }
});

function block0$5 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Button": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Button"}}
      }
    }
  });
}

if (typeof block0$5 === "function") block0$5(_sfc_main$x);

const _sfc_main$w = {
  __name: 'DSErrorBoundary',
  props: {
  fn: {
    type: Function,
    default: () => () => {},
  },
},
  setup(__props) {

const props = __props;

onErrorCaptured((error) => {
  if (props.fn && typeof props.fn === 'function')
    return props.fn(error)
});

return (_ctx, _cache) => {
  return renderSlot(_ctx.$slots, "default")
}
}

};

const INTERVAL = 100;
function useFakeProgress({ autoStart = true } = {}) {
  const progress = ref(0);
  const randomProgress = ref(0);
  const durationMs = ref(0);
  let i;
  let step;
  let updateTimer;
  let randomUpdateTimer;
  const startProgress = () => {
    updateTimer = setInterval(() => {
      onProgressUpdate();
    }, INTERVAL);
  };
  const onProgressUpdate = () => {
    durationMs.value += INTERVAL;
    i += step;
    progress.value = Math.round(Math.atan(i) / (Math.PI / 2) * 1e3) / 1e3;
    if (progress.value > 0.7)
      step = 0.1;
  };
  const startRandomProgressUpdate = () => {
    randomUpdateTimer = setTimeout(() => {
      randomProgress.value = progress.value;
      startRandomProgressUpdate();
    }, Math.random() * 1e3);
  };
  const start = () => {
    progress.value = 0;
    i = 0;
    step = 0.5;
    startProgress();
    startRandomProgressUpdate();
  };
  const end = () => {
    progress.value = 1;
    clearInterval(updateTimer);
    clearTimeout(randomUpdateTimer);
  };
  if (autoStart)
    start();
  return {
    progress,
    randomProgress,
    start,
    end,
    durationMs
  };
}

const _sfc_main$v = {
  __name: 'DSFakeProgressBar',
  props: {
  done: Boolean,
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const { progress, end } = useFakeProgress();

watch(() => props.done, (value) => {
  if (value) {
    end();
  }
});

onUnmounted(() => {
  end();
});

return (_ctx, _cache) => {
  return (openBlock(), createBlock(unref(_sfc_main$k), {
    percent: unref(progress) * 100,
    "custom-theme-object": __props.customThemeObject
  }, null, 8, ["percent", "custom-theme-object"]))
}
}

};

const _hoisted_1$c = { "data-ds-component": "grouped-data-template" };


const _sfc_main$u = {
  __name: 'DSGroupedDataTemplate',
  props: {
  data: Array,
  getGroupKey: Function,
  initialGroupKeys: {
    type: Array,
    required: false,
  },
  keyCompareFunction: {
    type: Function,
    default: safeIsEqual,
  },
},
  setup(__props) {

const props = __props;

const { params, groupedData } = useGroupData();

watch(
  () => props,
  () => Object.entries(props).forEach(([key, value]) => params[key] = value),
  {
    immediate: true,
    deep: true,
  },
);

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$c, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(groupedData), (group, index) => {
      return renderSlot(_ctx.$slots, "default", mergeProps({ ref_for: true }, { isFirst: index === 0, isLast: index + 1 === unref(groupedData).length, ...group }))
    }), 256))
  ]))
}
}

};

const _sfc_main$t = {
  __name: 'GetSlotHtml',
  props: {
  modelValue: {
    default: undefined,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const wrapper = ref(null);
async function onMutation() {
  await nextTick();
  const innerHTML = wrapper.value.innerHTML;
  emit('update:modelValue', innerHTML);
}

useMutationObserver(
  wrapper,
  () => {
    onMutation();
  },
  {
    childList: true,
    subtree: true,
  },
);

onMounted(() => {
  onMutation();
});

return (_ctx, _cache) => {
  return withDirectives((openBlock(), createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 512)), [
    [vShow, false]
  ])
}
}

};

const _hoisted_1$b = ["id"];
const _hoisted_2$4 = { class: "sr-only position-absolute top-0" };
const _hoisted_3$1 = ["innerHTML"];
const _hoisted_4 = {
  key: 0,
  class: "lineclamp-btn text-right"
};
const ELLIPSIS_CHARACTER = "…";
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "DSLineClamp",
  props: {
    content: {
      type: String
    },
    maxLines: {
      type: [Number, Object]
    },
    interactive: {
      type: Boolean,
      default: false
    },
    lineHeight: {
      type: Number,
      default: 22
    },
    openLabel: {
      type: String
    },
    closeLabel: {
      type: String
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const breakpoints = ["xs", "sm", "md", "lg", "xl", "xxl"];
    const { t } = useI18n();
    const slots = useSlots();
    const { current: currentBreakpoint } = useBreakpoints();
    const id = v4();
    const isExpanded = ref(false);
    const isTruncated = ref(false);
    const maxHeightByBreakpoint = reactive({
      xs: null,
      sm: null,
      md: null,
      lg: null,
      xl: null,
      xxl: null
    });
    const currentMaxHeight = ref(null);
    const currentMaxLines = ref(null);
    const debounceRender = debounce(() => render(), 150);
    const selfTrigger = ref(false);
    const defaultSlotHtml = ref(void 0);
    const el = ref(null);
    const elLineClamp = ref(null);
    const elLineClampContent = ref(null);
    const TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX = /[ .,;!?'‘’“”\-–—]+$/;
    const isResponsive = computed(() => {
      return typeof props.maxLines === "object";
    });
    const truncateElementNode = function(element, rootElement, maximumHeight, ellipsisCharacter) {
      const childNodes = element.childNodes;
      let i = childNodes.length - 1;
      while (i > -1) {
        const childNode = childNodes[i--];
        if (childNode.nodeType === 1 && truncateElementNode(
          childNode,
          rootElement,
          maximumHeight,
          ellipsisCharacter
        ) || childNode.nodeType === 3 && truncateTextNode(
          childNode,
          rootElement,
          maximumHeight,
          ellipsisCharacter
        ))
          return true;
        element.removeChild(childNode);
      }
      return false;
    };
    function truncateTextNode(textNode, rootElement, maximumHeight, ellipsisCharacter) {
      let lastIndexOfWhitespace;
      let textContent = textNode.textContent;
      while (textContent.length > 1) {
        lastIndexOfWhitespace = textContent.lastIndexOf(" ");
        if (lastIndexOfWhitespace === -1)
          break;
        textNode.textContent = textContent.substring(0, lastIndexOfWhitespace);
        if (rootElement.clientHeight <= maximumHeight) {
          textNode.textContent = textContent;
          break;
        }
        textContent = textNode.textContent;
      }
      return truncateTextNodeByCharacter(
        textNode,
        rootElement,
        maximumHeight,
        ellipsisCharacter
      );
    }
    function truncateTextNodeByCharacter(textNode, rootElement, maximumHeight, ellipsisCharacter) {
      let textContent = textNode.textContent;
      let length = textContent.length;
      while (length > 1) {
        textNode.textContent = textContent + ellipsisCharacter;
        if (rootElement.clientHeight <= maximumHeight)
          return true;
        textContent = textContent.substring(0, length - 1).replace(TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX, "");
        length = textContent.length;
      }
      return false;
    }
    function init() {
      initializeMaxHeights();
      render();
    }
    function initializeMaxHeights() {
      if (!isResponsive.value) {
        maxHeightByBreakpoint.xs = maxHeightByBreakpoint.sm = maxHeightByBreakpoint.md = maxHeightByBreakpoint.lg = maxHeightByBreakpoint.xl = maxHeightByBreakpoint.xxl = props.maxLines * props.lineHeight;
      } else {
        let lastMaxHeight = getFirstDefinedMaxHeight();
        breakpoints.forEach((bp) => {
          if (Object.hasOwn(props.maxLines, bp)) {
            lastMaxHeight = maxHeightByBreakpoint[bp] = props.maxLines[bp] * props.lineHeight;
          } else {
            maxHeightByBreakpoint[bp] = lastMaxHeight;
          }
        });
      }
    }
    function render() {
      updateConstraints();
      clamp();
      selfTrigger.value = true;
    }
    function updateConstraints() {
      currentMaxHeight.value = getMaxHeight(currentBreakpoint.value);
      currentMaxLines.value = getMaxLines(currentMaxHeight.value);
    }
    function getFirstDefinedMaxHeight() {
      const firstBreakpoint = breakpoints.find((bp) => props.maxLines[bp] !== void 0);
      const firstMaxLines = props.maxLines[firstBreakpoint];
      return firstMaxLines * props.lineHeight;
    }
    function getMaxHeight(breakpoint) {
      return maxHeightByBreakpoint[breakpoint];
    }
    function getMaxLines(maxHeight) {
      return maxHeight / props.lineHeight;
    }
    function clamp() {
      const innerHTML = typeof slots?.default === "function" && slots.default()?.[0] ? defaultSlotHtml.value : props.content;
      elLineClampContent.value.innerHTML = innerHTML;
      if (isExpanded.value)
        return;
      if (shouldTruncate())
        truncate();
      else
        isTruncated.value = false;
    }
    function shouldTruncate() {
      return elLineClamp.value.clientHeight > currentMaxHeight.value;
    }
    function truncate() {
      isTruncated.value = true;
      truncateElementNode(
        elLineClampContent.value,
        elLineClamp.value,
        currentMaxHeight.value,
        ELLIPSIS_CHARACTER
      );
    }
    function toggle() {
      isExpanded.value = !isExpanded.value;
    }
    onBeforeMount(() => {
      initializeMaxHeights();
    });
    onMounted(() => {
      useResizeObserver(el, () => {
        if (selfTrigger.value) {
          selfTrigger.value = false;
          return;
        }
        debounceRender();
      });
      if (props.expanded)
        isExpanded.value = true;
    });
    watch(
      () => props.maxLines,
      () => {
        init();
      }
    );
    watch(
      () => props.content,
      () => {
        render();
      }
    );
    watch(
      () => defaultSlotHtml.value,
      () => {
        render();
      }
    );
    watch(
      () => isExpanded.value,
      () => {
        clamp();
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: unref(id),
        ref_key: "el",
        ref: el,
        "data-ds-component": "line-clamp",
        class: normalizeClass(["lineclamp-component relative flex flex-col", { "lineclamp-clamped": !isExpanded.value }])
      }, [
        createElementVNode("div", {
          ref_key: "elLineClamp",
          ref: elLineClamp,
          class: "top-0"
        }, [
          createElementVNode("div", {
            ref_key: "elLineClampContent",
            ref: elLineClampContent,
            class: "lineclamp-content overflow-hidden",
            "aria-hidden": "true"
          }, null, 512)
        ], 512),
        createElementVNode("div", _hoisted_2$4, [
          renderSlot(_ctx.$slots, "default", {}, () => [
            createElementVNode("span", { innerHTML: __props.content }, null, 8, _hoisted_3$1)
          ], true)
        ]),
        __props.interactive && (isExpanded.value || !isExpanded.value && isTruncated.value) ? (openBlock(), createElementBlock("div", _hoisted_4, [
          createElementVNode("button", {
            class: "btn-sm inline-flex items-center gap-2px b-0 border-none bg-none p-0 text-12px color-inherit fw-400 case-normal",
            role: "button",
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => toggle(), ["prevent"]))
          }, [
            isExpanded.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(toDisplayString(__props.closeLabel ? __props.closeLabel : unref(t)("Show less")), 1),
              createVNode(_sfc_main$X, { icon: "i-far-angle-up" })
            ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(toDisplayString(__props.openLabel ? __props.openLabel : unref(t)("Show more")), 1),
              createVNode(_sfc_main$X, { icon: "i-far-angle-down" })
            ], 64))
          ])
        ])) : createCommentVNode("", true),
        __props.content === void 0 ? (openBlock(), createBlock(_sfc_main$t, {
          key: 1,
          modelValue: defaultSlotHtml.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => defaultSlotHtml.value = $event)
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["modelValue"])) : createCommentVNode("", true)
      ], 10, _hoisted_1$b);
    };
  }
});

function block0$4 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Show more": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Show more"}},
        "Show less": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Show less"}}
      },
      "es": {
        "Show more": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Mostrar más"}},
        "Show less": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Mostrar menos"}}
      }
    }
  });
}

function block1$1 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "de",
    "resource": {
      "Show more": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Mehr anzeigen"}},
      "Show less": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Weniger anzeigen"}}
    }
  });
}

function block2$1 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "Show more": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Afficher plus"}},
      "Show less": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Afficher moins"}}
    }
  });
}

if (typeof block0$4 === "function") block0$4(_sfc_main$s);
if (typeof block1$1 === "function") block1$1(_sfc_main$s);
if (typeof block2$1 === "function") block2$1(_sfc_main$s);
const DSLineClamp = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-0e5f1248"]]);

const _sfc_main$r = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "DSLoadingWrapper",
  props: {
    loading: { type: Boolean, default: false },
    noOverlay: { type: Boolean, default: false },
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.LOADING_WRAPPER, props.customThemeObject);
      return componentClasses;
    });
    return (_ctx, _cache) => {
      return _ctx.loading ? (openBlock(), createElementBlock("div", normalizeProps(mergeProps({ key: 0 }, _ctx.$attrs)), [
        createVNode(_sfc_main$F, {
          mode: "block",
          class: normalizeClass({ [theme.value.container]: !_ctx.noOverlay }),
          "data-testid": "ds-loading-wrapper-animation"
        }, null, 8, ["class"])
      ], 16)) : renderSlot(_ctx.$slots, "default", { key: 1 });
    };
  }
});

function block0$3 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Close": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Close"}}
      }
    }
  });
}

const _sfc_main$q = /*#__PURE__*/Object.assign({
  inheritAttrs: false,
}, {
  __name: 'DSModal',
  props: {
  allowClose: {
    type: Boolean,
    default: true,
  },
  modalClass: {
    type: String,
    required: false,
  },
  closeButtonClass: {
    type: String,
    required: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  customThemeObject: {
    type: Object,
    required: false,
  },
  static: Boolean,
},
  emits: [
  'show',
  'shown',
  'hide',
],
  setup(__props, { expose: __expose, emit: __emit }) {



const props = __props;

const emit = __emit;

const { t } = useI18n();
const modalElement = ref(null);
const returnFocusElement = ref(null);
const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.MODAL, props.customThemeObject);
  return componentClasses
});
const isOpen = ref(false);

function onShow() {
  emit('show');
  returnFocusElement.value = document.activeElement || document.body;
  if (!props.loading)
    onShown();
}

function onShown() {
  emit('shown');
  nextTick(() => {
    setFocus();
  });
}

function onHide() {
  emit('hide');
  returnFocusElement.value?.focus();
  returnFocusElement.value = null;
}

watch(isOpen, (isOpen) => {
  if (isOpen)
    onShow();
  else
    onHide();
});

function show() {
  isOpen.value = true;
}

if (props.static)
  show();

function hide() {
  isOpen.value = false;
  if (props.static)
    emit('hide');
}

function getFirstFocusableElement() {
  const el = modalElement;
  const focusableElements = el.value?.querySelectorAll(
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex^="-"]), [contenteditable]',
  );
  return focusableElements?.[0]
}

function setFocus() {
  const firstFocusableElement = getFirstFocusableElement();
  if (firstFocusableElement)
    firstFocusableElement.focus();
}

onBeforeUnmount(() => {
  if (isOpen.value)
    hide();
});

watch(() => props.loading, async (loading) => {
  if (loading || !isOpen.value)
    return
  onShown();
}, { immediate: true });

__expose({
  show,
  hide,
});

return (_ctx, _cache) => {
  const _directive_kbd_trap = resolveDirective("kbd-trap");

  return (openBlock(), createBlock(unref(TransitionRoot), {
    appear: "",
    as: "template",
    show: isOpen.value
  }, {
    default: withCtx(() => [
      createVNode(unref(Dialog), mergeProps({ as: "aside" }, _ctx.$attrs, {
        class: theme.value.container,
        "aria-label": unref(t)('Close'),
        onClose: _cache[1] || (_cache[1] = () => {
        __props.allowClose && hide();
      })
      }), {
        default: withCtx(() => [
          createVNode(unref(TransitionChild), {
            as: "template",
            enter: theme.value.modalEnter,
            "enter-from": theme.value.modalEnterFrom,
            "enter-to": theme.value.modalEnterTo,
            leave: theme.value.modalLeave,
            "leave-from": theme.value.modalEnterFrom,
            "leave-to": theme.value.modalEnterTo
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(theme.value.modalDialogOverlay)
              }, null, 2)
            ]),
            _: 1
          }, 8, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"]),
          (isOpen.value)
            ? (openBlock(), createBlock(_sfc_main$r, {
                key: 0,
                loading: __props.loading,
                "no-overlay": ""
              }, {
                default: withCtx(() => [
                  createVNode(unref(TransitionChild), {
                    as: "template",
                    enter: theme.value.modalLoadingEnter,
                    "enter-from": theme.value.modalLoadingEnterFrom,
                    "enter-to": theme.value.modalLoadingEnterTo,
                    leave: theme.value.modalLoadingLeave,
                    "leave-from": theme.value.modalLoadingLeaveFrom,
                    "leave-to": theme.value.modalLoadingLeaveTo
                  }, {
                    default: withCtx(() => [
                      withDirectives((openBlock(), createBlock(unref(DialogPanel), {
                        class: normalizeClass([__props.modalClass, theme.value.modalDialogPanel]),
                        role: "alertdialog",
                        "aria-modal": "true"
                      }, {
                        default: withCtx(() => [
                          createElementVNode("div", {
                            ref_key: "modalElement",
                            ref: modalElement
                          }, [
                            (__props.allowClose)
                              ? (openBlock(), createElementBlock("button", {
                                  key: 0,
                                  class: normalizeClass([__props.closeButtonClass, theme.value.modalClose]),
                                  onClick: _cache[0] || (_cache[0] = $event => (hide()))
                                }, [
                                  createVNode(_sfc_main$X, {
                                    icon: theme.value.modalCloseIcon,
                                    size: "32"
                                  }, null, 8, ["icon"])
                                ], 2))
                              : createCommentVNode("", true),
                            renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ hide: hide })))
                          ], 512)
                        ]),
                        _: 3
                      }, 8, ["class"])), [
                        [_directive_kbd_trap]
                      ])
                    ]),
                    _: 3
                  }, 8, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"])
                ]),
                _: 3
              }, 8, ["loading"]))
            : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["class", "aria-label"])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

});
if (typeof block0$3 === 'function') block0$3(_sfc_main$q);

const _hoisted_1$a = { key: 0 };


const _sfc_main$p = {
  __name: 'DSModalsContainer',
  props: {
  enterActiveClass: String,
  enterFromClass: String,
  enterToClass: String,
  leaveActiveClass: String,
  leaveFromClass: String,
  leaveToClass: String,
},
  setup(__props) {



const { modal, hide } = useModal();

return (_ctx, _cache) => {
  const _directive_kbd_trap = resolveDirective("kbd-trap");

  return (openBlock(), createBlock(Teleport, { to: "body" }, [
    (unref(modal))
      ? (openBlock(), createBlock(_sfc_main$N, {
          key: 0,
          class: "z-modal-backdrop"
        }))
      : createCommentVNode("", true),
    createVNode(Transition, {
      "enter-from-class": __props.enterFromClass,
      "enter-active-class": __props.enterActiveClass,
      "enter-to-class": __props.enterToClass,
      "leave-from-class": __props.leaveFromClass,
      "leave-active-class": __props.leaveActiveClass,
      "leave-to-class": __props.leaveToClass
    }, {
      default: withCtx(() => [
        (unref(modal))
          ? withDirectives((openBlock(), createElementBlock("div", _hoisted_1$a, [
              (openBlock(), createBlock(resolveDynamicComponent(unref(modal)), { onHide: unref(hide) }, null, 40, ["onHide"]))
            ])), [
              [_directive_kbd_trap]
            ])
          : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["enter-from-class", "enter-active-class", "enter-to-class", "leave-from-class", "leave-active-class", "leave-to-class"])
  ]))
}
}

};

const _hoisted_1$9 = ["innerHTML"];
const _hoisted_2$3 = ["innerHTML"];
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "Toast",
  props: {
    title: { default: "" },
    type: { default: "danger" },
    content: { default: "" },
    customThemeObject: {}
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.NOTIFIER, props.customThemeObject);
      return componentClasses;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass({
          [theme.value.danger]: _ctx.type === "danger",
          [theme.value.info]: _ctx.type === "info",
          [theme.value.success]: _ctx.type === "success",
          [theme.value.warning]: _ctx.type === "warning",
          [theme.value.utility]: _ctx.type === "utility",
          [theme.value.notifierToastWrapper]: true
        }),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
      }, [
        createElementVNode("div", {
          class: normalizeClass(theme.value.notifierToast)
        }, [
          _ctx.type === "danger" ? (openBlock(), createElementBlock("button", {
            key: 0,
            "data-testid": "ds-toast-button-close",
            class: normalizeClass(theme.value.notifierDangerIcon),
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event) => emit("close"))
          }, [
            createVNode(_sfc_main$X, {
              icon: theme.value.notifierToastClose
            }, null, 8, ["icon"])
          ], 2)) : createCommentVNode("", true),
          _ctx.title ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(theme.value.notifierToastHeader)
          }, [
            createElementVNode("div", {
              class: normalizeClass(theme.value.notifierTitleIconBoxWrapper)
            }, [
              createElementVNode("div", {
                class: normalizeClass(theme.value.notifierTitleIconBox)
              }, [
                createElementVNode("i", {
                  class: normalizeClass({
                    [theme.value.notifierTitleIconDanger]: _ctx.type === "danger",
                    [theme.value.notifierTitleIconInfo]: _ctx.type === "info",
                    [theme.value.notifierTitleIconSuccess]: _ctx.type === "success",
                    [theme.value.notifierTitleIconWarning]: _ctx.type === "warning",
                    [theme.value.notifierTitleIconUtility]: _ctx.type === "utility",
                    [theme.value.notifierTitleIcon]: true
                  })
                }, null, 2)
              ], 2),
              createElementVNode("div", {
                class: normalizeClass(theme.value.notifierTitle),
                innerHTML: _ctx.title
              }, null, 10, _hoisted_1$9)
            ], 2)
          ], 2)) : createCommentVNode("", true),
          _ctx.content ? (openBlock(), createElementBlock("div", {
            key: 2,
            class: normalizeClass(theme.value.notifierContent),
            innerHTML: _ctx.content
          }, null, 10, _hoisted_2$3)) : createCommentVNode("", true)
        ], 2)
      ], 2);
    };
  }
});

const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "DSNotifier",
  props: {
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.NOTIFIER, props.customThemeObject);
      return componentClasses;
    });
    const notifier = useNotifier();
    const toasts = ref([]);
    function close(toastId) {
      const toastIndex = toasts.value.findIndex((t) => t.value.id === toastId);
      toasts.value.slice(toastIndex, 1);
    }
    function hide(toast) {
      if (toast.value)
        toast.value.show = false;
      nextTick(() => setTimeout(() => close(toast.value?.id), 2e3));
    }
    function showToast(event) {
      const toast = ref({
        id: useId(),
        type: event.type,
        title: event.title,
        content: event.content,
        template: event.template,
        show: true
      });
      toasts.value.push(toast);
      if (toast.value.type !== "danger")
        nextTick(() => setTimeout(() => hide(toast), 5e3));
    }
    notifier.on(showToast);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "data-ds-component": "notifier",
        class: normalizeClass(theme.value.container)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(toasts.value, (toast) => {
          return renderSlot(_ctx.$slots, "default", mergeProps({
            key: toast.id,
            ref_for: true
          }, toast.value), () => [
            createVNode(unref(TransitionRoot), {
              appear: "",
              show: toast.value.show,
              enter: theme.value.notifierEnter,
              "enter-from": theme.value.notifierEnterFrom,
              "enter-to": theme.value.notifierEnterTo,
              leave: theme.value.notifierLeave,
              "leave-from": theme.value.notifierLeaveFrom,
              "leave-to": theme.value.notifierLeaveTo
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$o, {
                  type: toast.value.type,
                  title: toast.value.title,
                  content: toast.value.content,
                  "custom-theme-object": props.customThemeObject,
                  "data-testid": "ds-notifier-toast",
                  onClose: ($event) => hide(toast)
                }, null, 8, ["type", "title", "content", "custom-theme-object", "onClose"])
              ]),
              _: 2
            }, 1032, ["show", "enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"])
          ]);
        }), 128))
      ], 2);
    };
  }
});

const _sfc_main$m = /*#__PURE__*/Object.assign({
  inheritAttrs: false,
}, {
  __name: 'DSOffcanvas',
  props: {
  show: Boolean,
  zIndexClass: {
    type: String,
    default: 'z-offcanvas',
  },
  backdropZIndexClass: {
    type: String,
    default: 'z-offcanvas-backdrop',
  },
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {



const props = __props;

const emit = __emit;

const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.OFF_CANVAS, props.customThemeObject);
  return componentClasses
});

function close() {
  emit('close');
}

return (_ctx, _cache) => {
  const _directive_kbd_trap = resolveDirective("kbd-trap");

  return withDirectives((openBlock(), createElementBlock("div", {
    class: normalizeClass(theme.value.container),
    "data-ds-component": "offcanvas",
    onKeydown: withKeys(close, ["esc"])
  }, [
    createVNode(Transition, {
      appear: "",
      "enter-active-class": theme.value.offCanvasEnter,
      "enter-from-class": theme.value.offCanvasEnterFrom,
      "enter-to-class": theme.value.offCanvasEnterTo,
      "leave-active-class": theme.value.offCanvasLeave,
      "leave-from-class": theme.value.offCanvasLeaveFrom,
      "leave-to-class": theme.value.offCanvasLeaveTo
    }, {
      default: withCtx(() => [
        (__props.show)
          ? withDirectives((openBlock(), createElementBlock("div", mergeProps({ key: 0 }, _ctx.$attrs, {
              class: [__props.zIndexClass, theme.value.offCanvasContent]
            }), [
              renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ close: close })))
            ], 16)), [
              [unref(vFocus)]
            ])
          : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["enter-active-class", "enter-from-class", "enter-to-class", "leave-active-class", "leave-from-class", "leave-to-class"]),
    (__props.show)
      ? (openBlock(), createBlock(_sfc_main$N, {
          key: 0,
          class: normalizeClass([__props.backdropZIndexClass]),
          onClick: close
        }, null, 8, ["class"]))
      : createCommentVNode("", true)
  ], 34)), [
    [_directive_kbd_trap]
  ])
}
}

});

function block0$2 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Search by name or email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Search by name or email"}}
      }
    }
  });
}

function block1 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "de",
    "resource": {
      "Search by name or email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Suche nach Name oder E-Mail"}}
    }
  });
}

function block2 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "fr",
    "resource": {
      "Search by name or email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Rechercher par nom ou e-mail"}}
    }
  });
}

function block3 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "es",
    "resource": {
      "Search by name or email": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Buscar por nombre o correo electrónico"}}
    }
  });
}

const _hoisted_1$8 = {
  "data-ds-component": "person-combobox-input",
  "data-testid": "ds-person-input"
};


const _sfc_main$l = {
  __name: 'DSPersonComboboxInput',
  props: {
  options: {
    default: undefined,
  },
  modelValue: {
    default: undefined,
  },
  queryFunction: {
    default:
      () =>
        async ({ query, options }) => {
          if (!query)
            return options
          return options
            .filter(option =>
              [option?.label, option?.email].some(
                val =>
                  val && val.toLowerCase().includes(query.toString().toLowerCase()),
              ),
            )
            .map(option => ({
              ...option,
              label: option.label,
            }))
        },
  },
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

const currentValue = ref();

watch(
  () => props.modelValue,
  (value) => {
    currentValue.value = value;
  },
  {
    immediate: true,
  },
);

watch(currentValue, (value) => {
  if (props.modelValue !== value)
    emit('update:modelValue', value);
});

const theme = computed(() => {
  const { componentClasses } = useTheme(
    ThemeTypes.PERSON_COMBOBOX_INPUT,
    props.customThemeObject,
  );
  return componentClasses
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$8, [
    createVNode(_sfc_main$E, {
      modelValue: currentValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((currentValue).value = $event)),
      "data-testid": "ds-person-input-combobox",
      placeholder: unref(t)('Search by name or email'),
      class: "w-full",
      options: __props.options,
      "query-function": __props.queryFunction
    }, {
      custom: withCtx(({ row }) => [
        createElementVNode("div", {
          class: normalizeClass(theme.value.optionLayout)
        }, [
          createVNode(_sfc_main$P, {
            name: row.label,
            "image-url": row.imageUrl,
            class: "me-2"
          }, null, 8, ["name", "image-url"]),
          createElementVNode("div", {
            class: normalizeClass(theme.value.optionLabel)
          }, [
            createElementVNode("div", {
              class: normalizeClass(theme.value.optionName)
            }, toDisplayString(row.label), 3),
            (row.email)
              ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(theme.value.optionEmail)
                }, toDisplayString(row.email), 3))
              : createCommentVNode("", true)
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "options", "query-function"])
  ]))
}
}

};
if (typeof block0$2 === 'function') block0$2(_sfc_main$l);
if (typeof block1 === 'function') block1(_sfc_main$l);
if (typeof block2 === 'function') block2(_sfc_main$l);
if (typeof block3 === 'function') block3(_sfc_main$l);

const _sfc_main$k = {
  __name: 'DSProgressBar',
  props: {
  percent: {
    type: Number,
    default: 0,
    required: true,
    validator: val => val >= 0 && val <= 100,
  },
  showText: {
    type: Boolean,
    default: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
  lineHeight: {
    type: Number,
    default: 20,
  },
  customThemeObject: {
    type: Object,
    required: false,
  },
  format: Function,
},
  setup(__props) {

const props = __props;

const theme = computed(() => {
  const { componentClasses } = useTheme(
    ThemeTypes.PROGRESS_BAR,
    props.customThemeObject,
  );
  return componentClasses
});

const percentVal = computed(() => {
  if (props.percent <= 0)
    return 0

  else if (props.percent >= 100)
    return 100

  return props.percent
});

const content = computed(() => {
  if (typeof props.format === 'function')
    return props.format(percentVal.value) || ''

  return `${Math.trunc(percentVal.value)}%`
});

function addStyle(property, value, unit = '') {
  return value ? `${property}: ${value}${unit};` : ''
}

const outerHeightStyle = computed(() => {
  return addStyle('height', props.lineHeight, 'px')
});

const lineStyle = computed(() => {
  const result = [
    addStyle('width', percentVal.value, '%'),
    addStyle('height', props.lineHeight, 'px'),
    addStyle('margin-top', -props.lineHeight, 'px'),
  ];

  return result.join(';')
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    "data-ds-component": "progress-bar",
    "data-testid": "progress-bar",
    class: normalizeClass(theme.value.container)
  }, [
    createElementVNode("div", {
      class: normalizeClass(theme.value.outer)
    }, [
      createElementVNode("div", {
        class: normalizeClass(theme.value.barBg),
        style: normalizeStyle(outerHeightStyle.value)
      }, null, 6),
      createElementVNode("div", {
        class: normalizeClass(theme.value.outerLine),
        style: normalizeStyle(lineStyle.value)
      }, [
        (__props.active)
          ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(theme.value.outerLineActive)
            }, null, 2))
          : createCommentVNode("", true)
      ], 6)
    ], 2),
    (__props.showText)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(theme.value.text),
          "data-testid": "progress-bar-text"
        }, toDisplayString(content.value), 3))
      : createCommentVNode("", true)
  ], 2))
}
}

};

const _sfc_main$j = {
  __name: 'DSComponentPropsValueAdapter',
  props: {
  is: [Object, Function],
  props: Object,
  attrs: Object,
},
  setup(__props) {

const props = __props;

const componentProps = computed(() =>
  Object
    .entries(props.props)
    .reduce((acc, [key, value]) => {
      acc[key] = toValue(value);
      return acc
    }, {}),
);

return (_ctx, _cache) => {
  return (openBlock(), createBlock(resolveDynamicComponent(__props.is), normalizeProps(guardReactiveProps({ ...componentProps.value, ...__props.attrs })), null, 16))
}
}

};

const _hoisted_1$7 = { "data-ds-component": "provider" };


const _sfc_main$i = {
  __name: 'DSProvider',
  setup(__props) {

const attrs = useAttrs();
Object
  .entries(attrs)
  .forEach(([key]) => {
    provide(key, computed(() => attrs[key]));
  });

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$7, [
    renderSlot(_ctx.$slots, "default")
  ]))
}
}

};

const _hoisted_1$6 = ["disabled", "onMouseover", "onFocus", "onClick"];
const _hoisted_2$2 = { class: "sr-only" };
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "DSRating",
  props: {
    modelValue: {},
    disabled: { type: Boolean, default: false },
    customThemeObject: {}
  },
  emits: ["update:model-value"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const value = computed({
      get: () => props.modelValue,
      set: (value2) => emit("update:model-value", value2)
    });
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.RATING, props.customThemeObject);
      return componentClasses;
    });
    const hoverIndex = ref(0);
    const displayValue = computed(() => hoverIndex.value || value.value);
    function getIcon(index) {
      if (index <= displayValue.value)
        return theme.value.ratingStar;
      if (index >= Math.ceil(displayValue.value) + 1)
        return theme.value.ratingStarL;
      return theme.value.ratingHalfStar;
    }
    const { t } = useI18n();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "data-ds-component": "rating",
        class: normalizeClass(theme.value.container)
      }, [
        (openBlock(), createElementBlock(Fragment, null, renderList(5, (i) => {
          return createElementVNode("button", {
            key: i,
            disabled: _ctx.disabled,
            "data-testid": "ds-rating-button",
            onMouseover: ($event) => hoverIndex.value = i,
            onFocus: ($event) => hoverIndex.value = i,
            onMouseout: _cache[0] || (_cache[0] = ($event) => hoverIndex.value = 0),
            onBlur: _cache[1] || (_cache[1] = ($event) => hoverIndex.value = 0),
            onClick: ($event) => value.value = i
          }, [
            createVNode(_sfc_main$X, {
              icon: getIcon(i),
              size: "48",
              "data-testid": "ds-icon-component"
            }, null, 8, ["icon"]),
            createElementVNode("span", _hoisted_2$2, toDisplayString(`${i} ${unref(t)("Stars")}`), 1)
          ], 40, _hoisted_1$6);
        }), 64))
      ], 2);
    };
  }
});

function block0$1 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "Stars": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Stars"}}
      },
      "de": {
        "Stars": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Sterne"}}
      },
      "fr": {
        "Stars": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Étoiles"}}
      },
      "es": {
        "Stars": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"Estrellas"}}
      }
    }
  });
}

if (typeof block0$1 === "function") block0$1(_sfc_main$h);

const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "DSRadio",
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean },
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.RADIO, props.customThemeObject);
      return componentClasses;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "data-ds-component": "radio",
        class: normalizeClass([_ctx.checked && "checked", _ctx.disabled && "disabled", theme.value.container])
      }, null, 2);
    };
  }
});

function getScrollParent(node, axis = "y") {
  let el = node;
  if (!(el instanceof HTMLElement || el instanceof ShadowRoot))
    return null;
  if (el instanceof ShadowRoot)
    el = el.host;
  const style = window.getComputedStyle(el);
  const overflow = axis === "y" ? style.overflowY : style.overflowX;
  const scrollSize = axis === "y" ? el.scrollHeight : el.scrollWidth;
  const clientSize = axis === "y" ? el.clientHeight : el.clientWidth;
  const isScrolled = scrollSize > clientSize;
  if (isScrolled && !overflow.includes("visible") && !overflow.includes("hidden"))
    return el;
  return getScrollParent(el.parentNode, axis);
}

const _sfc_main$f = {
  __name: 'Manager',
  props: {
  modelValue: String,
  offset: {
    type: Number,
    default: 0,
  },
  orientation: {
    type: String,
    default: 'vertical',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const anchors = reactive({});
const anchorStarts = ref({});
const orientationDimension = computed(() => props.orientation === 'vertical' ? 'y' : 'x');
const el = ref(null);
const scrollParent = ref(null);
const scrollParentOrWindow = computed(() => scrollParent.value || window);
const scrollParentOrDocument = computed(() => scrollParent.value || document);
let disableSetCurrentAnchor = false;
let disableSetCurrentAnchorTimer = false;

const parentScroll = useScroll(scrollParentOrWindow, {
  onStop: () => {
    disableSetCurrentAnchor = false;
    setCurrentAnchor();
  },
});
const parentScrollPosition = computed({
  get: () => parentScroll[orientationDimension.value].value,
  set: value => parentScroll[orientationDimension.value].value = value,
});

const elementBounding = useElementBounding(scrollParent);
const parentOffset = computed(() => elementBounding?.[orientationDimension.value]?.value || 0);

function updateAnchorStarts() {
  const parentOffsetWithScrollPosition = parentScrollPosition.value - parentOffset.value;
  const starts = Object.entries(anchors)
    .filter(([, el]) => el)
    .map(([name, el]) => {
      const rect = el.getBoundingClientRect();
      const position = rect[orientationDimension.value];
      const positionRelativeToParent = position + parentOffsetWithScrollPosition;
      return [name, positionRelativeToParent]
    })
    .reduce((obj, [name, position]) => {
      obj[name] = position;
      return obj
    }, {});
  anchorStarts.value = starts;
}

function register({ name, el }) {
  anchors[name] = el;
}

function unregister(name) {
  anchors[name] = undefined;
  delete anchors[name];
}

async function scrollTo(name) {
  updateAnchorStarts();
  const anchorPosition = anchorStarts.value[name];

  if (anchorPosition === undefined) {
    disableSetCurrentAnchor = false;
    return
  }
  disableSetCurrentAnchor = true;

  const scrollToPosition = anchorPosition - props.offset + 1;

  parentScrollPosition.value = scrollToPosition;
}

const api = {
  register,
  unregister,
};

const value = ref(undefined);

function setCurrentAnchor() {
  if (disableSetCurrentAnchor || disableSetCurrentAnchorTimer)
    return

  const scrollPosition = parentScrollPosition.value;
  let currentAnchor;
  // get anchor starts in reverse order by position, so the first one less than current position is the right one
  const reverseSortedAnchorStarts = Object.entries(anchorStarts.value)
    .sort(([, anchorAStart], [, anchorBStart]) => anchorBStart - anchorAStart);
  // if at top, get first anchor
  if (scrollPosition === 0) {
    currentAnchor = reverseSortedAnchorStarts.at(-1);
  }
  else {
    // if at bottom, get last anchor
    if (parentScroll.arrivedState.bottom) {
      currentAnchor = reverseSortedAnchorStarts[0];
    }
    else {
      // otherwise, find first anchor whose start position is less than current scroll position (+ offset)
      currentAnchor = reverseSortedAnchorStarts.find(([, position]) => {
        return position <= scrollPosition + props.offset
      });
      // if not past any anchor, use first anchor
      if (!currentAnchor)
        currentAnchor = reverseSortedAnchorStarts.at(-1);
    }
  }
  if (!currentAnchor)
    return
  const [currentAnchorName] = currentAnchor;
  value.value = currentAnchorName;
}

const state = computed(() => ({
  value: value.value,
  scrollParent: scrollParent.value,
  parentScrollPosition: parentScrollPosition.value,
  parentOffset: parentOffset.value,
  orientation: props.orientation,
  offset: props.offset,
}));

provide('scrollspy', {
  state: toReactive(state),
  api,
});

function initialize() {
  const scrollParentValue = getScrollParent(
    el.value,
    orientationDimension.value,
  );

  useMutationObserver(scrollParentOrDocument, () => {
    updateAnchorStarts();
  }, { childList: true, subtree: true });
  useResizeObserver(scrollParentValue, () => {
    updateAnchorStarts();
  });

  updateAnchorStarts();
}

onMounted(() => {
  disableSetCurrentAnchorTimer = true;
  initialize();
  if (props.modelValue) {
    setTimeout(() => {
      scrollTo(props.modelValue);
      disableSetCurrentAnchorTimer = false;
    }, 1000);
  }
});

watch(
  () => [parentOffset.value, anchors.value],
  () => updateAnchorStarts(),
);

watch(
  () => [anchorStarts.value, parentScrollPosition.value],
  () => {
    setCurrentAnchor();
  },
);

watch(value, (anchorName) => {
  if (props.modelValue === anchorName)
    return
  emit('update:modelValue', anchorName);
});

watch(() => props.modelValue, async (anchorName) => {
  if (value.value === anchorName)
    return
  disableSetCurrentAnchor = true;

  scrollTo(anchorName);
}, { immediate: true });

__expose({
  update: updateAnchorStarts,
  scrollTo,
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    ref_key: "el",
    ref: el,
    "data-ds-component": "scrollspy"
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

};

const _hoisted_1$5 = ["name", "data-active"];


const _sfc_main$e = {
  __name: 'Anchor',
  props: {
  name: {
    type: String,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {

const { name } = __props;

const el = ref(null);
const scrollspy = inject('scrollspy');
const isActive = computed(() => scrollspy?.state?.value === name);

onMounted(() => {
  // scrollspy.api.register(el.value.__vueParentComponent.exposed)
  scrollspy.api.register({ name, el });
});

onBeforeUnmount(() => {
  scrollspy.api.unregister(name);
});

__expose({
  name,
  el,
});

// defineOptions({
//   inject: [
//     'scrollspy',
//   ],
//   computed: {
//     active() {
//       // scrollspy?.state?.value === props.name)
//     },
//   },
//   mounted() {
//     this.scrollspy.api.register(this)
//   },
// })

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("a", {
    ref_key: "el",
    ref: el,
    name: __props.name,
    "data-active": isActive.value
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1$5))
}
}

};

const index = {
  Manager: _sfc_main$f,
  Anchor: _sfc_main$e
};

const index$1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  Anchor: _sfc_main$e,
  Manager: _sfc_main$f,
  default: index
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$4 = { "data-ds-component": "stepper" };
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "DSStepper",
  props: {
    steps: {},
    currentStepIndex: {},
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.STEPPER, props.customThemeObject);
      return componentClasses;
    });
    const totalSteps = computed(() => {
      return props.steps?.length;
    });
    const currentStep = computed(() => {
      return props.currentStepIndex < totalSteps.value ? props.steps?.[props.currentStepIndex] : props.steps?.[totalSteps.value - 1];
    });
    function state(index) {
      if (index > props.currentStepIndex)
        return void 0;
      if (index === props.currentStepIndex)
        return "incomplete";
      return "complete";
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$4, [
        createElementVNode("div", {
          class: normalizeClass([theme.value.containerMobile])
        }, [
          createElementVNode("div", {
            class: normalizeClass([theme.value.currentStepMobileWrapper])
          }, [
            createElementVNode("div", {
              class: normalizeClass([theme.value.currentStepMobile])
            }, toDisplayString(currentStep.value), 3),
            createElementVNode("div", {
              class: normalizeClass([theme.value.progressBarMobileWrapper])
            }, [
              createElementVNode("div", {
                class: normalizeClass([theme.value.progressBarMobile])
              }, null, 2),
              createElementVNode("div", {
                class: normalizeClass([theme.value.currentStepIndexMobile, _ctx.currentStepIndex < totalSteps.value ? theme.value.currentStepIndexMobileIncomplete : theme.value.currentStepIndexMobileComplete])
              }, null, 2)
            ], 2),
            createElementVNode("div", {
              class: normalizeClass([theme.value.roundedMobile])
            }, toDisplayString(_ctx.steps.indexOf(currentStep.value) + 1) + "/" + toDisplayString(totalSteps.value), 3)
          ], 2)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass([theme.value.containerDesktop])
        }, [
          createElementVNode("div", {
            class: normalizeClass([theme.value.stepsWrapper])
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(props.steps, (step, index) => {
              return openBlock(), createElementBlock("div", {
                key: step,
                class: normalizeClass([theme.value.steps])
              }, [
                createElementVNode("div", {
                  class: normalizeClass([theme.value.stepsCircleWrapper])
                }, [
                  createElementVNode("div", {
                    class: normalizeClass([
                      state(index) ? theme.value.stepsCircleWithBgSecondary : theme.value.stepsCircleWithBgSurface,
                      theme.value.stepsCircle
                    ])
                  }, [
                    createElementVNode("div", {
                      class: normalizeClass([theme.value.stepsCircleInner])
                    }, [
                      !state(index) ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: normalizeClass([theme.value.stepsRounded])
                      }, null, 2)) : state(index) === "incomplete" ? (openBlock(), createElementBlock("div", {
                        key: 1,
                        class: normalizeClass([theme.value.stepsRoundedIncomplete])
                      }, null, 2)) : state(index) === "complete" ? (openBlock(), createElementBlock("i", {
                        key: 2,
                        class: normalizeClass([theme.value.stepsRoundedComplete])
                      }, null, 2)) : createCommentVNode("", true)
                    ], 2)
                  ], 2),
                  createElementVNode("div", {
                    class: normalizeClass([
                      theme.value.smallText,
                      !state(index) ? theme.value.smallTextMissing : "",
                      state(index) === "incomplete" ? theme.value.smallTextIncomplete : "",
                      state(index) === "complete" ? theme.value.smallTextComplete : ""
                    ])
                  }, toDisplayString(step), 3)
                ], 2),
                createElementVNode("div", {
                  class: normalizeClass([theme.value.progressBar])
                }, [
                  createElementVNode("div", {
                    class: normalizeClass([theme.value.rounded])
                  }, null, 2),
                  state(index) ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: normalizeClass([
                      theme.value.roundedInner,
                      state(index) === "incomplete" ? theme.value.roundedInnerIncomplete : "",
                      state(index) === "complete" ? theme.value.roundedInnerComplete : ""
                    ])
                  }, null, 2)) : createCommentVNode("", true)
                ], 2)
              ], 2);
            }), 128))
          ], 2)
        ], 2)
      ]);
    };
  }
});

const _sfc_main$c = {
  __name: 'DSStacked',
  props: {
  group: {
    type: String,
    required: true,
  },
  groupOffset: {
    type: Number,
    default: 0,
  },
  offset: {
    type: Number,
    default: 0,
  },
  rank: {
    type: Number,
    default: 0,
  },
  hideWhenFixed: {
    type: Boolean,
    default: true,
  },
  stickyClasses: String,
  stickyClass: {
    type: String,
    default: 'z-sticky',
  },
  enabled: {
    type: Boolean,
    default: true,
  },
  teleportTarget: {
    type: [String, HTMLElement],
    default: 'body',
  },
  position: {
    type: String,
    default: 'fixed',
  },
},
  setup(__props) {

const props = __props;

const {
  offset,
  groupOffset,
  rank,
  enabled,
} = toRefs(props);

const el = ref(null);

const { isFixed, itemState } = useStackingItem(el, {
  rank,
  offset,
  groupId: props.group,
  groupOffset,
  enabled,
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", {
      ref_key: "el",
      ref: el,
      class: normalizeClass({ invisible: unref(isFixed) && __props.hideWhenFixed }),
      "data-ds-component": "stacked"
    }, [
      renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ isFixed: false })))
    ], 2),
    (openBlock(), createBlock(Teleport, { to: __props.teleportTarget }, [
      (unref(isFixed))
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["w-full", [__props.stickyClass, __props.stickyClasses]]),
            style: normalizeStyle({
        position: __props.position,
        ...(unref(itemState)?.top !== undefined && { top: `${unref(itemState).top}px` }),
      })
          }, [
            renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ isFixed: true })))
          ], 6))
        : createCommentVNode("", true)
    ], 8, ["to"]))
  ], 64))
}
}

};

const _hoisted_1$3 = ["disabled", "aria-checked"];
const _hoisted_2$1 = ["innerHTML"];
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "DSSwitch",
  props: {
    label: {},
    checked: { type: Boolean },
    static: { type: Boolean },
    reverse: { type: Boolean },
    disabled: { type: Boolean, default: false },
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.SWITCH, props.customThemeObject);
      return componentClasses;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("label", {
        "data-ds-component": "switch",
        class: normalizeClass(theme.value.container)
      }, [
        createElementVNode("div", {
          class: normalizeClass({ [theme.value.switchButtonWrapperReverse]: _ctx.reverse, [theme.value.switchButtonWrapper]: true }),
          "data-testid": "ds-switch-flex-container"
        }, [
          createElementVNode("button", mergeProps({
            disabled: _ctx.disabled,
            class: [_ctx.checked ? theme.value.switchButtonChecked : theme.value.switchButtonUnchecked, theme.value.switchButton]
          }, _ctx.$attrs, {
            role: "switch",
            "aria-checked": _ctx.checked
          }), [
            createElementVNode("span", {
              class: normalizeClass([_ctx.checked ? theme.value.switchToggleChecked : theme.value.switchToggleUnchecked, theme.value.switchToggle])
            }, null, 2)
          ], 16, _hoisted_1$3),
          _ctx.label ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass(theme.value.switchLabel),
            innerHTML: _ctx.label
          }, null, 10, _hoisted_2$1)) : createCommentVNode("", true)
        ], 2)
      ], 2);
    };
  }
});

const _hoisted_1$2 = ["onClick"];


const _sfc_main$a = {
  __name: 'DSTabBar',
  props: {
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Number,
    required: true,
  },
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  emits: ['update:modelValue'],
  setup(__props) {

const props = __props;



const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.TAB_BAR, props.customThemeObject);
  return componentClasses
});

const hasTwoOptions = computed(() => {
  return props?.options.length === 2
});

const containerStyle = computed(() => {
  if (hasTwoOptions.value)
    return theme.value.tabBarTwoOptions
  else return theme.value.tabBarSingleOptions
});

function setActive(id) {
  if (id === props?.modelValue)
    return theme.value.tabBarTabActive
}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(theme.value.container)
  }, [
    createElementVNode("ul", {
      class: normalizeClass([containerStyle.value])
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (tab) => {
        return (openBlock(), createElementBlock("li", {
          key: tab.value,
          class: normalizeClass([hasTwoOptions.value && theme.value.tabBarTabTwoOptions])
        }, [
          (tab.isDisabled)
            ? (openBlock(), createElementBlock("button", {
                key: 0,
                class: normalizeClass([hasTwoOptions.value && theme.value.tabBarButtonTwoOptions, theme.value.tabBarButtonDisabled])
              }, [
                (tab.icon)
                  ? (openBlock(), createBlock(_sfc_main$X, {
                      key: 0,
                      class: normalizeClass(theme.value.tabBarButtonDisabledIcon),
                      icon: tab.icon
                    }, null, 8, ["class", "icon"]))
                  : createCommentVNode("", true),
                createTextVNode(" " + toDisplayString(tab.label), 1)
              ], 2))
            : (openBlock(), createElementBlock("button", {
                key: 1,
                role: "button",
                class: normalizeClass([setActive(tab.value), hasTwoOptions.value && theme.value.tabBarButtonTwoOptions, theme.value.tabBarButton]),
                onClick: $event => (_ctx.$emit('update:modelValue', tab.value))
              }, [
                (tab.icon)
                  ? (openBlock(), createBlock(_sfc_main$X, {
                      key: 0,
                      class: normalizeClass(theme.value.tabBarButtonIcon),
                      icon: tab.icon
                    }, null, 8, ["class", "icon"]))
                  : createCommentVNode("", true),
                createElementVNode("p", {
                  class: normalizeClass(hasTwoOptions.value && theme.value.tabBarButtonLabelTwoOptions)
                }, toDisplayString(tab.label), 3)
              ], 10, _hoisted_1$2))
        ], 2))
      }), 128))
    ], 2)
  ], 2))
}
}

};

const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "DSTable",
  props: {
    scrollable: { type: Boolean },
    unstriped: { type: Boolean, default: true },
    customThemeObject: {}
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.TABLE, props.customThemeObject);
      return componentClasses;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "data-ds-component": "table",
        class: normalizeClass({
          [theme.value.tableContainerScrollable]: _ctx.scrollable,
          [theme.value.container]: true
        })
      }, [
        createElementVNode("table", mergeProps(_ctx.$attrs, {
          "data-testid": "ds-tableComponent-table",
          class: {
            [theme.value.tableScrollable]: _ctx.scrollable,
            [theme.value.tableStriped]: !_ctx.unstriped,
            [theme.value.table]: true
          }
        }), [
          renderSlot(_ctx.$slots, "default")
        ], 16)
      ], 2);
    };
  }
});

const _sfc_main$8 = {
  name: 'DSTableCell',
  props: {
    customThemeObject: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.TABLE_CELL, props.customThemeObject);
      return componentClasses
    });
    return { theme }
  },
};

function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("td", {
    class: normalizeClass($setup.theme.container)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2))
}
const DSTableCell = /*#__PURE__*/_export_sfc(_sfc_main$8, [['render',_sfc_render$2]]);

const _sfc_main$7 = {
  name: 'DSTableHeader',
  props: {
    customThemeObject: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.TABLE_HEADER, props.customThemeObject);
      return componentClasses
    });
    return { theme }
  },
};

function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("th", {
    class: normalizeClass($setup.theme.container)
  }, [
    createElementVNode("div", {
      class: normalizeClass($setup.theme.tableHeader)
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
const DSTableHeader = /*#__PURE__*/_export_sfc(_sfc_main$7, [['render',_sfc_render$1]]);

const _sfc_main$6 = {
  name: 'DSTableRow',
  props: {
    customThemeObject: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.TABLE_ROW, props.customThemeObject);
      return componentClasses
    });
    return { theme }
  },
};

function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("tr", {
    class: normalizeClass($setup.theme.container)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2))
}
const DSTableRow = /*#__PURE__*/_export_sfc(_sfc_main$6, [['render',_sfc_render]]);

const _sfc_main$5 = {
  __name: 'DSThemeProvider',
  props: {
  theme: { type: Object, required: true },
},
  setup(__props) {

const props = __props;

const flatThemeArray = computed(() => {
  if (!props.theme)
    return []
  const flatObj = flatten(props.theme, { safe: true });
  const transformedObj = Object.keys(flatObj).reduce((obj, key) => {
    const newKey = key
      .replaceAll('.', '-')
      .replace('-DEFAULT', '')
      .replace(/([A-Z])/g, '-$1')
      .toLowerCase();
    obj[newKey] = Array.isArray(flatObj[key]) ? flatObj[key].join(', ') : flatObj[key];
    return obj
  }, {});
  return Object.entries(transformedObj)
});

return (_ctx, _cache) => {
  return (openBlock(), createBlock(resolveDynamicComponent("style"), null, {
    default: withCtx(() => [
      createTextVNode(" :root { "),
      (openBlock(true), createElementBlock(Fragment, null, renderList(flatThemeArray.value, (row) => {
        return (openBlock(), createElementBlock(Fragment, null, [
          createTextVNode(toDisplayString('\r\n\t\t') + " --" + toDisplayString(row[0]) + ": " + toDisplayString(row[1]) + "; ", 1)
        ], 64))
      }), 256)),
      createTextVNode(" " + toDisplayString('\r\n') + " } " + toDisplayString('\r\n'))
    ]),
    _: 1
  }))
}
}

};

const _hoisted_1$1 = ["innerHTML"];
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "DataTableColumnCell",
  props: {
    column: {},
    row: {},
    customThemeObject: {}
  },
  setup(__props) {
    function renderColumnRowHtmlTemplate(column, row) {
      return column.template(row);
    }
    function getColumnRowComponent(column, row) {
      return {
        ...column.component,
        data() {
          return { ...row };
        }
      };
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(DSTableCell, { "custom-theme-object": _ctx.customThemeObject }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, _ctx.column.slot || null, normalizeProps(guardReactiveProps({ ..._ctx.row })), () => [
            _ctx.column.component ? (openBlock(), createBlock(resolveDynamicComponent(getColumnRowComponent(_ctx.column, _ctx.row)), {
              key: 0,
              row: _ctx.row,
              "custom-theme-object": _ctx.customThemeObject
            }, null, 8, ["row", "custom-theme-object"])) : _ctx.column.template ? (openBlock(), createElementBlock("div", {
              key: 1,
              innerHTML: renderColumnRowHtmlTemplate(_ctx.column, _ctx.row)
            }, null, 8, _hoisted_1$1)) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
              createTextVNode(toDisplayString(unref(resolve)(_ctx.row, _ctx.column.key)), 1)
            ], 64))
          ])
        ]),
        _: 3
      }, 8, ["custom-theme-object"]);
    };
  }
});

const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "DataTableColumnGroup",
  props: {
    data: {},
    dataKey: {},
    summaryRowClass: {},
    summaryColumns: {},
    columns: {},
    columnGroup: {},
    customThemeObject: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_DataTableColumnGroup = resolveComponent("DataTableColumnGroup", true);
      return openBlock(), createElementBlock(Fragment, null, [
        _ctx.summaryColumns ? (openBlock(), createBlock(DSTableRow, {
          key: 0,
          "custom-theme-object": _ctx.customThemeObject,
          class: normalizeClass(["summary", [_ctx.summaryRowClass]])
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.summaryColumns, (column, i) => {
              return openBlock(), createBlock(_sfc_main$4, {
                key: i,
                column,
                row: _ctx.data,
                "custom-theme-object": _ctx.customThemeObject
              }, null, 8, ["column", "row", "custom-theme-object"]);
            }), 128)),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columns.length - _ctx.summaryColumns.length, (i) => {
              return openBlock(), createBlock(DSTableCell, {
                key: i,
                "custom-theme-object": _ctx.customThemeObject
              }, null, 8, ["custom-theme-object"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["custom-theme-object", "class"])) : createCommentVNode("", true),
        _ctx.columns ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.data, (row, i) => {
          return openBlock(), createElementBlock(Fragment, { key: i }, [
            createVNode(DSTableRow, { "custom-theme-object": _ctx.customThemeObject }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columns, (column, i2) => {
                  return openBlock(), createBlock(_sfc_main$4, {
                    key: i2,
                    column,
                    row,
                    "custom-theme-object": _ctx.customThemeObject
                  }, null, 8, ["column", "row", "custom-theme-object"]);
                }), 128))
              ]),
              _: 2
            }, 1032, ["custom-theme-object"]),
            _ctx.columnGroup ? (openBlock(), createBlock(_component_DataTableColumnGroup, mergeProps({
              key: i,
              data: unref(resolve)(row, _ctx.columnGroup.dataKey),
              ref_for: true
            }, { ..._ctx.columnGroup }, { "custom-theme-object": _ctx.customThemeObject }), null, 16, ["data", "custom-theme-object"])) : createCommentVNode("", true)
          ], 64);
        }), 128)) : createCommentVNode("", true)
      ], 64);
    };
  }
});

const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "DSBadge",
  props: {
    customThemeObject: { default: null }
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.BADGE, props.customThemeObject);
      return componentClasses;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(theme.value.container)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});

const _sfc_main$1 = {
  __name: 'DSDataSorter',
  props: {
  columnKey: {
    type: String,
    required: true,
  },
  customThemeObject: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props;
const dataQueryStore = inject('data-query-store');

const state = computed(() => {
  const matchedSortIndex = dataQueryStore.value.state.value?.sortBy?.findIndex(({ key }) => key === props.columnKey);
  if (matchedSortIndex === -1)
    return { direction: 'inactive' }
  return {
    direction: dataQueryStore.value.state.value.sortBy[matchedSortIndex].direction,
    order: dataQueryStore.value.state.value.sortBy.length > 1 ? matchedSortIndex + 1 : undefined,
  }
});

const theme = computed(() => {
  const { componentClasses } = useTheme(ThemeTypes.DATA_SORTER, props.customThemeObject);
  return componentClasses
});

const orderIconClass = computed(() => {
  switch (state.value.order) {
    case 1: return theme.value.dataSorterBadgeIcon1
    case 2: return theme.value.dataSorterBadgeIcon2
    case 3: return theme.value.dataSorterBadgeIcon3
    case 4: return theme.value.dataSorterBadgeIcon4
    case 5: return theme.value.dataSorterBadgeIcon5
    case 6: return theme.value.dataSorterBadgeIcon6
    case 7: return theme.value.dataSorterBadgeIcon7
    case 8: return theme.value.dataSorterBadgeIcon8
    case 9: return theme.value.dataSorterBadgeIcon9
    default: return ''
  }
});

function sort() {
  dataQueryStore.value.actions?.updateSortBy(props.columnKey);
}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("button", {
    "data-ds-component": "data-sorter",
    class: normalizeClass(theme.value.container),
    onClick: sort
  }, [
    createElementVNode("i", {
      class: normalizeClass({
        [theme.value.dataSorterIconInactive]: state.value.direction === 'inactive',
        [theme.value.dataSorterIconAsc]: state.value.direction === 'asc',
        [theme.value.dataSorterIconDesc]: state.value.direction === 'desc',
        [theme.value.dataSorterIcon]: true,
      })
    }, null, 2),
    (orderIconClass.value)
      ? (openBlock(), createBlock(_sfc_main$2, {
          key: 0,
          class: normalizeClass(theme.value.dataSorterBadge)
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$X, {
              icon: [orderIconClass.value, theme.value.dataSorterBadgeIcon]
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["class"]))
      : createCommentVNode("", true)
  ], 2))
}
}

};

const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DSDataTable",
  props: {
    data: {},
    columns: {},
    scrollable: { type: Boolean },
    selectable: { type: Boolean },
    isAllSelected: { type: Boolean },
    isSelected: { type: Function },
    groupedColumns: {},
    unstriped: { type: Boolean },
    loading: { type: Boolean },
    customThemeObject: {},
    rowGroups: {}
  },
  emits: ["toggle:select", "toggle:select-all"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const theme = computed(() => {
      const { componentClasses } = useTheme(ThemeTypes.DATA_TABLE, props.customThemeObject);
      return componentClasses;
    });
    const { t } = useI18n();
    const headers = computed(() => (props.columns ? props.columns : props.groupedColumns?.headers) || []);
    const type = computed(() => props.groupedColumns ? "grouped" : "simple");
    const noResults = computed(() => props.data && props.data.length === 0);
    onMounted(() => {
      if (props.rowGroups && props.columns)
        console.warn('DataTable: Only one of "columns" and "rowGroups" should be specified!');
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        "data-ds-component": "data-table",
        class: normalizeClass({ [theme.value.container]: true })
      }, [
        createElementVNode("div", {
          class: normalizeClass({ [theme.value.dataTableScrollableContainer]: _ctx.scrollable, [theme.value.dataTableScrollable]: _ctx.scrollable })
        }, [
          createVNode(_sfc_main$r, {
            class: normalizeClass(theme.value.dataTableLoadingWrapper),
            loading: _ctx.loading,
            "custom-theme-object": _ctx.customThemeObject
          }, {
            default: withCtx(() => [
              !noResults.value ? (openBlock(), createElementBlock("div", _hoisted_1, [
                createVNode(_sfc_main$9, {
                  scrollable: _ctx.scrollable,
                  unstriped: _ctx.unstriped,
                  "custom-theme-object": _ctx.customThemeObject
                }, {
                  default: withCtx(() => [
                    createVNode(DSTableRow, { "custom-theme-object": _ctx.customThemeObject }, {
                      default: withCtx(() => [
                        _ctx.selectable ? (openBlock(), createBlock(DSTableHeader, {
                          key: 0,
                          class: normalizeClass(theme.value.dataTableSelectableCell),
                          "custom-theme-object": _ctx.customThemeObject
                        }, {
                          default: withCtx(() => [
                            createVNode(_sfc_main$Z, {
                              checked: _ctx.isAllSelected,
                              "custom-theme-object": _ctx.customThemeObject,
                              onClick: _cache[0] || (_cache[0] = ($event) => emit("toggle:select-all"))
                            }, null, 8, ["checked", "custom-theme-object"])
                          ]),
                          _: 1
                        }, 8, ["class", "custom-theme-object"])) : createCommentVNode("", true),
                        (openBlock(true), createElementBlock(Fragment, null, renderList(headers.value, (header) => {
                          return openBlock(), createBlock(DSTableHeader, {
                            key: header.name,
                            "custom-theme-object": _ctx.customThemeObject
                          }, {
                            default: withCtx(() => [
                              renderSlot(_ctx.$slots, header.headerSlot || null, {}, () => [
                                createTextVNode(toDisplayString(header.name) + " ", 1),
                                header.headerTooltip ? (openBlock(), createBlock(_sfc_main$Y, {
                                  key: 0,
                                  content: header.headerTooltip,
                                  variant: header.toolTipVariant ? header.toolTipVariant : theme.value.dataTableTooltipVariant,
                                  "other-classes": theme.value.dataTableTooltipOtherClasses,
                                  "custom-theme-object": _ctx.customThemeObject
                                }, null, 8, ["content", "variant", "other-classes", "custom-theme-object"])) : createCommentVNode("", true)
                              ]),
                              header.sortable && header.key ? (openBlock(), createBlock(_sfc_main$1, {
                                key: 0,
                                "column-key": header.key,
                                "custom-theme-object": _ctx.customThemeObject
                              }, null, 8, ["column-key", "custom-theme-object"])) : createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["custom-theme-object"]);
                        }), 128))
                      ]),
                      _: 3
                    }, 8, ["custom-theme-object"]),
                    type.value === "simple" ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.data, (row, index) => {
                      return openBlock(), createBlock(DSTableRow, {
                        key: index,
                        "custom-theme-object": _ctx.customThemeObject
                      }, {
                        default: withCtx(() => [
                          _ctx.selectable ? (openBlock(), createBlock(DSTableCell, {
                            key: 0,
                            class: normalizeClass(theme.value.dataTableSelectableCell),
                            "custom-theme-object": _ctx.customThemeObject
                          }, {
                            default: withCtx(() => [
                              createVNode(_sfc_main$Z, {
                                checked: _ctx.isSelected && _ctx.isSelected(row),
                                "custom-theme-object": _ctx.customThemeObject,
                                onClick: ($event) => emit("toggle:select", row)
                              }, null, 8, ["checked", "custom-theme-object", "onClick"])
                            ]),
                            _: 2
                          }, 1032, ["class", "custom-theme-object"])) : createCommentVNode("", true),
                          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columns, (column) => {
                            return openBlock(), createBlock(_sfc_main$4, {
                              key: column.name,
                              column,
                              row,
                              "custom-theme-object": _ctx.customThemeObject
                            }, createSlots({ _: 2 }, [
                              renderList(_ctx.$slots, (_, slot) => {
                                return {
                                  name: slot,
                                  fn: withCtx((scope) => [
                                    renderSlot(_ctx.$slots, slot, mergeProps({ ref_for: true }, { ...scope }))
                                  ])
                                };
                              })
                            ]), 1032, ["column", "row", "custom-theme-object"]);
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["custom-theme-object"]);
                    }), 128)) : type.value === "grouped" ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      _ctx.groupedColumns.columnGroup ? (openBlock(), createBlock(_sfc_main$3, mergeProps({
                        key: 0,
                        data: _ctx.groupedColumns.columnGroup.dataKey ? unref(resolve)(_ctx.data, _ctx.groupedColumns.columnGroup.dataKey) : _ctx.data
                      }, { ..._ctx.groupedColumns.columnGroup }, { "custom-theme-object": _ctx.customThemeObject }), null, 16, ["data", "custom-theme-object"])) : createCommentVNode("", true)
                    ], 64)) : createCommentVNode("", true)
                  ]),
                  _: 3
                }, 8, ["scrollable", "unstriped", "custom-theme-object"]),
                _ctx.scrollable ? (openBlock(), createElementBlock("div", _hoisted_2)) : createCommentVNode("", true)
              ])) : (openBlock(), createElementBlock("div", _hoisted_3, [
                renderSlot(_ctx.$slots, "no-data", {}, () => [
                  createTextVNode(toDisplayString(unref(t)("No Data Found")), 1)
                ])
              ]))
            ]),
            _: 3
          }, 8, ["class", "loading", "custom-theme-object"])
        ], 2)
      ], 2);
    };
  }
});

function block0 (Component) {
  const _Component = Component;
  _Component.__i18n = _Component.__i18n || [];
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-us": {
        "No Data Found": {"t":0,"b":{"t":2,"i":[{"t":3}],"s":"No Data Found"}}
      }
    }
  });
}

if (typeof block0 === "function") block0(_sfc_main);

const components = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  DSAccordion,
  DSAlert: _sfc_main$U,
  DSAsyncButton: _sfc_main$S,
  DSAvatar: _sfc_main$P,
  DSAvatarList: _sfc_main$O,
  DSBackdrop: _sfc_main$N,
  DSBreadcrumbs: _sfc_main$M,
  DSButton: _sfc_main$_,
  DSCalendar,
  DSCalendarInput,
  DSCard: _sfc_main$K,
  DSCheckbox: _sfc_main$$,
  DSCheckboxInput: _sfc_main$Z,
  DSChip: _sfc_main$J,
  DSClipboard: _sfc_main$I,
  DSCollapse: _sfc_main$W,
  DSComboboxInput: _sfc_main$E,
  DSComponentPropsValueAdapter: _sfc_main$j,
  DSCssVariables: _sfc_main$D,
  DSDataPager: _sfc_main$C,
  DSDataPagerSummary: _sfc_main$B,
  DSDataTable: _sfc_main,
  DSDateCalendarInput,
  DSDateRangeInput: _sfc_main$z,
  DSDebugInfo: _sfc_main$y,
  DSDropdown: _sfc_main$x,
  DSErrorBoundary: _sfc_main$w,
  DSFakeProgressBar: _sfc_main$v,
  DSGroupedDataTemplate: _sfc_main$u,
  DSIcon: _sfc_main$X,
  DSImage: _sfc_main$L,
  DSLineClamp,
  DSListboxInput,
  DSLoadingWrapper: _sfc_main$r,
  DSModal: _sfc_main$q,
  DSModalsContainer: _sfc_main$p,
  DSNotifier: _sfc_main$n,
  DSNumberInput: _sfc_main$10,
  DSOffcanvas: _sfc_main$m,
  DSPersonComboboxInput: _sfc_main$l,
  DSPopup,
  DSProgressBar: _sfc_main$k,
  DSProvider: _sfc_main$i,
  DSRadio: _sfc_main$g,
  DSRadioInput: _sfc_main$11,
  DSRating: _sfc_main$h,
  DSScrollspy: index$1,
  DSSpinner: _sfc_main$F,
  DSStacked: _sfc_main$c,
  DSStepper: _sfc_main$d,
  DSSwitch: _sfc_main$b,
  DSTabBar: _sfc_main$a,
  DSTable: _sfc_main$9,
  DSTableCell,
  DSTableHeader,
  DSTableRow,
  DSThemeProvider: _sfc_main$5,
  DSTooltip: _sfc_main$Y
}, Symbol.toStringTag, { value: 'Module' }));

export { _sfc_main$m as A, _sfc_main$l as B, _sfc_main$k as C, DSAccordion as D, _sfc_main$j as E, _sfc_main$i as F, _sfc_main$h as G, _sfc_main$g as H, index$1 as I, _sfc_main$F as J, _sfc_main$b as K, _sfc_main$c as L, _sfc_main$d as M, _sfc_main$a as N, _sfc_main$9 as O, DSTableCell as P, DSTableHeader as Q, DSTableRow as R, _sfc_main$5 as S, _sfc_main as T, _sfc_main$U as _, _sfc_main$S as a, _sfc_main$P as b, components as c, _sfc_main$O as d, _sfc_main$N as e, _sfc_main$M as f, _sfc_main$K as g, _sfc_main$J as h, _sfc_main$I as i, _sfc_main$W as j, _sfc_main$E as k, _sfc_main$D as l, _sfc_main$C as m, _sfc_main$B as n, _sfc_main$z as o, _sfc_main$y as p, _sfc_main$x as q, _sfc_main$w as r, _sfc_main$v as s, _sfc_main$u as t, _sfc_main$L as u, DSLineClamp as v, _sfc_main$r as w, _sfc_main$q as x, _sfc_main$p as y, _sfc_main$n as z };
//# sourceMappingURL=index-IaTSZESL.js.map
